(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[127],{

/***/ 6211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ ErrorPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/ErrorPage/errorPage.module.css
var errorPage_module = __webpack_require__(6455);
var errorPage_module_default = /*#__PURE__*/__webpack_require__.n(errorPage_module);
// EXTERNAL MODULE: ./node_modules/@awell-health/ui-library/dist/index.js
var dist = __webpack_require__(3066);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
;// CONCATENATED MODULE: ./src/components/ErrorPage/ErrorPage.tsx




var ErrorPage = function(param) {
    var title = param.title, children = param.children, onRetry = param.onRetry;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (errorPage_module_default()).error_page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (errorPage_module_default()).error_page_content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (errorPage_module_default()).error_icon_container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (errorPage_module_default()).error_icon_shadow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: "1.5",
                                stroke: "currentColor",
                                className: (errorPage_module_default()).error_icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (errorPage_module_default()).error_text,
                        children: title
                    }),
                    onRetry && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (errorPage_module_default()).try_again_btn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            "data-cy": "tryAgainButton",
                            onClick: function() {
                                return onRetry();
                            },
                            children: t("session.try_again")
                        })
                    })
                ]
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ErrorPage/index.ts



/***/ }),

/***/ 6557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ LoadingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/LoadingPage/loadingPage.module.css
var loadingPage_module = __webpack_require__(3614);
var loadingPage_module_default = /*#__PURE__*/__webpack_require__.n(loadingPage_module);
;// CONCATENATED MODULE: ./src/components/LoadingPage/LoadingPage.tsx


var LoadingPage = function(param) {
    var _showLogoBox = param.showLogoBox, showLogoBox = _showLogoBox === void 0 ? false : _showLogoBox;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (loadingPage_module_default()).loading_container,
        "data-testid": "loading-page",
        children: [
            showLogoBox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (loadingPage_module_default()).logo_box,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (loadingPage_module_default()).logo_shadow
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (loadingPage_module_default()).loading_indicators,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (loadingPage_module_default()).loading_indicators,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (loadingPage_module_default()).loading_indicator
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (loadingPage_module_default()).loading_indicator
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (loadingPage_module_default()).loading_indicator
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/LoadingPage/index.ts



/***/ }),

/***/ 8264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ NoSSRComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var Wrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/**
 * This component disables SSR on all its children components.
 */ var NoSSRComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(Wrapper), {
    ssr: false
});


/***/ }),

/***/ 7624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nI": function() { return /* reexport */ ActivitiesContainer; },
  "iE": function() { return /* reexport */ CloseHostedSessionModal; },
  "mf": function() { return /* reexport */ ErrorPage/* ErrorPage */.m; },
  "h2": function() { return /* reexport */ LoadingPage/* LoadingPage */.h; }
});

// UNUSED EXPORTS: Form, Message

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(4727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(4251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(2875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(969);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@awell-health/ui-library/dist/index.js
var dist = __webpack_require__(3066);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/types/generated/types-orchestration.tsx
var types_orchestration = __webpack_require__(5852);
;// CONCATENATED MODULE: ./src/hooks/useForm/types.ts


// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
;// CONCATENATED MODULE: ./src/hooks/useForm/useForm.ts





var useForm = function(activity) {
    var ref;
    var variables = {
        id: activity.object.id
    };
    var ref1 = (0,types_orchestration/* useGetFormQuery */.q6)({
        variables: variables
    }), formData = ref1.data, loading = ref1.loading, error = ref1.error, refetch = ref1.refetch;
    var t = (0,esm/* useTranslation */.$G)().t;
    if (loading) {
        return {
            loading: true
        };
    }
    if (error || (0,lodash.isNil)(formData === null || formData === void 0 ? void 0 : (ref = formData.form) === null || ref === void 0 ? void 0 : ref.form)) {
        var message = (error === null || error === void 0 ? void 0 : error.message) || t("activities.form.loading_error");
        var populatedError = error || new Error("Error fetching form");
        (0,esm_exports/* captureException */.Tb)(populatedError, {
            contexts: {
                form: {
                    form_id: activity.object.id
                },
                activity: (0,_object_spread/* default */.Z)({}, activity),
                graphql: {
                    query: "GetForm",
                    variables: JSON.stringify(variables)
                }
            }
        });
        return {
            loading: false,
            error: message,
            refetch: refetch
        };
    }
    return {
        loading: false,
        form: formData === null || formData === void 0 ? void 0 : formData.form.form,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useForm/index.ts


;// CONCATENATED MODULE: ./src/hooks/useEvaluateFormRules/types.ts


;// CONCATENATED MODULE: ./src/hooks/useEvaluateFormRules/useEvaluateFormRules.ts






var useEvaluateFormRules = function(form_id) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,types_orchestration/* useEvaluateFormRulesMutation */.lj)(), 1), evaluateFormRules = ref[0];
    return [
        function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(answers) {
                var variables, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            variables = {
                                input: {
                                    form_id: form_id,
                                    answers: answers
                                }
                            };
                            _ctx.next = 4;
                            return evaluateFormRules({
                                variables: variables,
                                onError: function(error) {
                                    (0,esm_exports/* captureException */.Tb)(error, {
                                        contexts: {
                                            form: {
                                                form_id: form_id
                                            },
                                            answers: (0,_object_spread/* default */.Z)({}, answers),
                                            graphql: {
                                                query: "EvaluateFormRules",
                                                variables: JSON.stringify(variables)
                                            }
                                        }
                                    });
                                }
                            });
                        case 4:
                            data = _ctx.sent.data;
                            if (data) {
                                _ctx.next = 7;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 7:
                            return _ctx.abrupt("return", data.evaluateFormRules.results);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            return _ctx.abrupt("return", []);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function(answers) {
                return _ref.apply(this, arguments);
            };
        }(), 
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useEvaluateFormRules/index.ts


;// CONCATENATED MODULE: ./src/components/Form/types.ts


// EXTERNAL MODULE: ./src/components/LoadingPage/index.ts + 1 modules
var LoadingPage = __webpack_require__(6557);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(1444);
;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/types.ts


// EXTERNAL MODULE: ./src/hooks/useLogging/index.ts + 1 modules
var useLogging = __webpack_require__(4128);
// EXTERNAL MODULE: ./src/hooks/useLogging/types.ts
var types = __webpack_require__(5064);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(8732);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(990);
;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/utils.ts


var getErrorMessage = function(error, defaultMessage) {
    if ((0,_instanceof/* default */.Z)(error, errors/* ApolloError */.cA)) {
        return error.message;
    }
    return defaultMessage;
};

;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/useSubmitForm.ts












var useSubmitForm = function(activity) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activity.id;
    var ref = (0,_sliced_to_array/* default */.Z)((0,types_orchestration/* useSubmitFormResponseMutation */.hp)(), 1), submitFormResponse = ref[0];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var ref2 = (0,useLogging/* useLogging */.K)(), infoLog = ref2.infoLog, errorLog = ref2.errorLog;
    /**
   *
   * @param response Form response
   * @returns true if the form response was successfully submitted
   */ var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var variables, errors, _message, errorText;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        variables = {
                            input: {
                                activity_id: activity_id,
                                response: response
                            }
                        };
                        infoLog({
                            msg: "Trying to submit a form response",
                            activity: activity
                        }, types/* LogEvent.FORM_SUBMITTING */.g.FORM_SUBMITTING);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return submitFormResponse({
                            variables: variables
                        });
                    case 6:
                        errors = _ctx.sent.errors;
                        if (!(!(0,lodash.isNil)(errors) && errors.length > 0)) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        throw new Error((_message = errors[0].message) !== null && _message !== void 0 ? _message : "Something went wrong while submitting the form response");
                    case 10:
                        infoLog({
                            msg: "Form response submitted",
                            activity: activity
                        }, types/* LogEvent.FORM_SUBMITTED */.g.FORM_SUBMITTED);
                        setIsSubmitting(false);
                        return _ctx.abrupt("return", true);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](3);
                        errorLog({
                            msg: "Failed to submit form response",
                            response: response,
                            activity: activity
                        }, _ctx.t0, types/* LogEvent.FORM_SUBMISSION_FAILED */.g.FORM_SUBMISSION_FAILED);
                        setIsSubmitting(false);
                        errorText = getErrorMessage(_ctx.t0, t("activities.form.saving_error"));
                        react_toastify_esm/* toast.error */.Am.error(errorText);
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                activity: activity,
                                form: {
                                    response: JSON.stringify(variables)
                                },
                                graphql: {
                                    query: "SubmitFormResponse",
                                    variables: JSON.stringify(variables)
                                }
                            }
                        });
                        return _ctx.abrupt("return", false);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    15
                ]
            ]);
        }));
        return function onSubmit(response) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onSubmit: onSubmit,
        isSubmitting: isSubmitting
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/index.ts


// EXTERNAL MODULE: ./src/components/ErrorPage/index.ts + 1 modules
var ErrorPage = __webpack_require__(6211);
// EXTERNAL MODULE: ./src/services/ErrorReporter/index.ts + 1 modules
var ErrorReporter = __webpack_require__(8644);
// EXTERNAL MODULE: ./src/services/ErrorReporter/addSentryBreadcrumb.ts
var addSentryBreadcrumb = __webpack_require__(2041);
// EXTERNAL MODULE: ./node_modules/use-local-storage/dist/index.js
var use_local_storage_dist = __webpack_require__(7844);
var use_local_storage_dist_default = /*#__PURE__*/__webpack_require__.n(use_local_storage_dist);
// EXTERNAL MODULE: ./src/hooks/useHostedSession/index.ts + 5 modules
var useHostedSession = __webpack_require__(4287);
;// CONCATENATED MODULE: ./src/components/Form/Form.tsx






















var Form = function(param) {
    var activity = param.activity;
    var ref = useForm(activity), isFetching = ref.loading, form = ref.form, error = ref.error, refetch = ref.refetch;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useEvaluateFormRules(activity.object.id), 1), evaluateFormRules = ref1[0];
    var ref2 = useSubmitForm(activity), onSubmit = ref2.onSubmit, isSubmitting = ref2.isSubmitting;
    var ref3 = (0,useHostedSession/* useHostedSession */.H)(), branding = ref3.branding, theme = ref3.theme;
    var ref4 = (0,useLogging/* useLogging */.K)(), infoLog = ref4.infoLog, errorLog = ref4.errorLog;
    var ref5 = (0,_sliced_to_array/* default */.Z)(use_local_storage_dist_default()(activity.id, ""), 2), formProgress = ref5[0], setFormProgress = ref5[1];
    if (isFetching) {
        infoLog({
            activity: activity,
            formProgress: formProgress
        }, types/* LogEvent.FORM_WAITING_FOR_FETCH */.g.FORM_WAITING_FOR_FETCH);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    if (error || (0,lodash.isNil)(form)) {
        errorLog({
            activity: activity,
            form: form
        }, error ? error : "Form is null", types/* LogEvent.FORM_FETCH_FAILED */.g.FORM_FETCH_FAILED);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.form.loading_error"),
            onRetry: refetch
        });
    }
    if (isSubmitting) {
        infoLog({
            activity: activity,
            form: form
        }, types/* LogEvent.FORM_WAITING_FOR_SUBMISSION */.g.FORM_WAITING_FOR_SUBMISSION);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    var modifiedQuestions = form === null || form === void 0 ? void 0 : form.questions.map(function(question) {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, question), {
            options: question === null || question === void 0 ? void 0 : (ref = question.options) === null || ref === void 0 ? void 0 : ref.map(function(option) {
                // @ts-expect-error - TODO: deprecate `value` and replace it with `value_string` completely.
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
                    value: option === null || option === void 0 ? void 0 : option.value_string
                });
            })
        });
    });
    var modifiedForm = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
        questions: modifiedQuestions
    });
    var handleEvaluateFormRules = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                            category: addSentryBreadcrumb/* BreadcrumbCategory.EVALUATE_FORM_RULES */.j.EVALUATE_FORM_RULES,
                            data: {
                                form_id: form === null || form === void 0 ? void 0 : form.id,
                                response: (0,ErrorReporter/* masker */.g)(response)
                            }
                        });
                        return _ctx.abrupt("return", evaluateFormRules(response));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleEvaluateFormRules(response) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var isSubmitted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                            category: addSentryBreadcrumb/* BreadcrumbCategory.SUBMIT_FORM */.j.SUBMIT_FORM,
                            data: {
                                form_id: form === null || form === void 0 ? void 0 : form.id,
                                response: (0,ErrorReporter/* masker */.g)(response)
                            }
                        });
                        _ctx.next = 3;
                        return onSubmit(response);
                    case 3:
                        isSubmitted = _ctx.sent;
                        if (isSubmitted) {
                            setFormProgress(undefined);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(response) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnAnswersChange = function(response) {
        if (response !== formProgress) {
            setFormProgress(response);
        }
    };
    var labels = {
        yes_label: t("activities.form.questions.yes_no.yes_answer"),
        no_label: t("activities.form.questions.yes_no.no_answer"),
        select: {
            search_placeholder: t("activities.form.questions.select.search_placeholder"),
            no_options: t("activities.form.questions.select.no_options")
        },
        slider: {
            tooltip_guide: t("activities.form.questions.slider.tooltip_guide")
        }
    };
    var button_labels = {
        prev: (0,lodash.isEmpty)(theme.locales.form.previous_question_label) ? t("activities.form.previous_question_label") : theme.locales.form.previous_question_label,
        next: (0,lodash.isEmpty)(theme.locales.form.next_question_label) ? t("activities.form.next_question_label") : theme.locales.form.next_question_label,
        submit: (0,lodash.isEmpty)(theme.locales.form.cta_submit) ? t("activities.form.cta_submit") : theme.locales.form.cta_submit
    };
    var error_labels = {
        required: t("activities.form.question_required_error"),
        sliderNotTouched: t("activities.form.slider_not_touched_error"),
        invalidPhoneNumber: t("activities.form.invalid_phone_number"),
        formHasErrors: t("activities.form.form_has_errors"),
        dateCannotBeInTheFuture: t("activities.form.date_cannot_be_in_the_future"),
        dateCannotBeInThePast: t("activities.form.date_cannot_be_in_the_past"),
        dateCannotBeToday: t("activities.form.date_cannot_be_today"),
        notANumber: t("activities.form.not_a_number"),
        numberOutOfRange: t("activities.form.number_out_of_range")
    };
    var renderTraditionalForm = activity.form_display_mode && activity.form_display_mode === types_orchestration/* FormDisplayMode.Regular */.OJ.Regular;
    var ref6, ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderTraditionalForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TraditionalForm, {
                form: modifiedForm,
                questionLabels: labels,
                buttonLabels: button_labels,
                errorLabels: error_labels,
                onSubmit: handleSubmit,
                evaluateDisplayConditions: handleEvaluateFormRules,
                storedAnswers: formProgress,
                onAnswersChange: handleOnAnswersChange,
                autosaveAnswers: (ref6 = branding === null || branding === void 0 ? void 0 : branding.hosted_page_autosave) !== null && ref6 !== void 0 ? ref6 : true
            }),
            !renderTraditionalForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ConversationalForm, {
                form: modifiedForm,
                questionLabels: labels,
                buttonLabels: button_labels,
                errorLabels: error_labels,
                onSubmit: handleSubmit,
                evaluateDisplayConditions: handleEvaluateFormRules,
                storedAnswers: formProgress,
                onAnswersChange: handleOnAnswersChange,
                autoProgress: (ref7 = branding === null || branding === void 0 ? void 0 : branding.hosted_page_auto_progress) !== null && ref7 !== void 0 ? ref7 : false,
                autosaveAnswers: (ref8 = branding === null || branding === void 0 ? void 0 : branding.hosted_page_autosave) !== null && ref8 !== void 0 ? ref8 : true,
                showProgressBar: theme.form.showProgressBar
            })
        ]
    });
};
Form.displayName = "Form";

;// CONCATENATED MODULE: ./src/components/Form/index.ts


;// CONCATENATED MODULE: ./src/components/Activities/context/ActivityContext.ts

var initialContext = {
    currentActivity: undefined,
    waitingForNewActivities: true
};
var ActivityContext = (0,react.createContext)(initialContext);

;// CONCATENATED MODULE: ./src/components/Activities/types.ts


// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9779);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(6252);
// EXTERNAL MODULE: ./src/services/graphql/index.ts + 2 modules
var graphql = __webpack_require__(4342);
;// CONCATENATED MODULE: ./src/hooks/useSessionActivities/types.ts


;// CONCATENATED MODULE: ./src/hooks/useSessionActivities/useSessionActivities.ts
/* eslint-disable react-hooks/exhaustive-deps */ 






var useSessionActivities = function() {
    var variables = {
        only_stakeholder_activities: true
    };
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref = (0,types_orchestration/* useGetHostedSessionActivitiesQuery */.a$)({
        variables: variables,
        onError: function(error) {
            (0,esm_exports/* captureException */.Tb)(error, {
                contexts: {
                    graphql: {
                        query: "GetHostedSessionActivities",
                        variables: JSON.stringify(variables)
                    }
                }
            });
        }
    }), data = ref.data, error = ref.error, loading = ref.loading, refetch = ref.refetch, startPolling = ref.startPolling, stopPolling = ref.stopPolling;
    var onActivityCreated = (0,types_orchestration/* useOnSessionActivityCreatedSubscription */.Ed)({
        variables: variables
    });
    /**
   * Why use these subscriptions if we don't do anything with the data ?
   * Because the apollo cache already does the job for us. Any activity that is
   * returned via these subscriptions will automatically be updated in the cache,
   * which means the `activities` array will also be automatically updated.
   */ (0,types_orchestration/* useOnSessionActivityCompletedSubscription */.tF)({
        variables: variables
    });
    (0,types_orchestration/* useOnSessionActivityExpiredSubscription */.bK)({
        variables: variables
    });
    var sortActivitiesByDate = function(activities) {
        if ((0,lodash.isNil)(activities) || (0,lodash.isEmpty)(activities)) {
            return [];
        }
        return (0,lodash.sortBy)(activities, function(activity) {
            return new Date(activity.date);
        });
    };
    var _activities;
    var activities = sortActivitiesByDate((_activities = data === null || data === void 0 ? void 0 : data.hostedSessionActivities.activities) !== null && _activities !== void 0 ? _activities : []);
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(onActivityCreated.data)) {
            var sessionActivityCreated = onActivityCreated.data.sessionActivityCreated;
            var updatedActivities = sortActivitiesByDate([
                sessionActivityCreated, 
            ].concat((0,_to_consumable_array/* default */.Z)(activities)));
            var updatedQuery = (0,graphql/* updateQuery */.rh)(data, [
                "hostedSessionActivities",
                "activities"
            ], updatedActivities);
            client.writeQuery({
                query: types_orchestration/* GetHostedSessionActivitiesDocument */.Wy,
                variables: variables,
                data: updatedQuery
            });
        }
    }, [
        onActivityCreated.data
    ]);
    return {
        activities: activities,
        loading: loading,
        error: error === null || error === void 0 ? void 0 : error.message,
        refetch: refetch,
        startPolling: startPolling,
        stopPolling: stopPolling
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSessionActivities/index.ts



;// CONCATENATED MODULE: ./src/components/Activities/context/ActivityProvider.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 









var POLLING_DELAY = 5000 // 5 seconds
;
var isActive = function(activity) {
    return (activity === null || activity === void 0 ? void 0 : activity.status) === types_orchestration/* ActivityStatus.Active */.fU.Active;
};
/**
 * TODO: Remove the granular logs once we have successfully diagnosed the issue with the
 * same activities being loaded multiple times.
 */ /**
 * Provider to store of the current activity being shown to user
 * and to determine the next activity from the activities list.
 */ var ActivityProvider = function(param) {
    var children = param.children;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(), currentActivity = ref[0], setCurrentActivity = ref[1];
    var ref1 = useSessionActivities(), activities = ref1.activities, loading = ref1.loading, error = ref1.error, refetch = ref1.refetch, startPolling = ref1.startPolling, stopPolling = ref1.stopPolling;
    var ref2 = (0,useLogging/* useLogging */.K)(), infoLog = ref2.infoLog, errorLog = ref2.errorLog;
    // activities list changes as we get new activities from the server or as we complete activities
    // this useEffect drives whole AHP logic, only by activities being changed in apollo cache
    // and base on their status do we determine what to show to the user
    (0,react.useEffect)(function() {
        if (!loading) {
            // get current from the list, it may be updated
            var current = activities.find(function(param) {
                var id = param.id;
                return id === (currentActivity === null || currentActivity === void 0 ? void 0 : currentActivity.id);
            });
            infoLog({
                msg: "Activities list changed",
                activities: activities,
                prevCurrentActivity: currentActivity,
                nextCurrentActivity: current,
                numberOfActivities: activities.length
            }, types/* LogEvent.ACTIVITIES_LIST_CHANGED */.g.ACTIVITIES_LIST_CHANGED);
            // try and change current activity if it's not active
            if (!isActive(current)) {
                var firstActive = activities.find(isActive);
                if ((0,lodash.isNil)(firstActive)) {
                    // nothing to activate, start polling for new activities so we don't rely on subscriptions
                    setCurrentActivity(undefined);
                    startPolling(POLLING_DELAY);
                    infoLog({
                        msg: "No active activity found, starting polling"
                    }, types/* LogEvent.ACTIVITIES_START_POLLING */.g.ACTIVITIES_START_POLLING);
                } else {
                    // we have something to activate, stop polling, no need for it
                    setCurrentActivity(firstActive);
                    stopPolling();
                    infoLog({
                        msg: "Active activity found, stopping polling",
                        firstActive: firstActive
                    }, types/* LogEvent.ACTIVITIES_STOP_POLLING */.g.ACTIVITIES_STOP_POLLING);
                }
            } else {
                infoLog({
                    msg: "Current activity is active",
                    current: current
                }, types/* LogEvent.ACTIVITY_IS_ACTIVE */.g.ACTIVITY_IS_ACTIVE);
            }
            infoLog({
                msg: "Fetched activities for session",
                activities: activities,
                current: current,
                numberOfActivities: activities.length
            }, types/* LogEvent.ACTIVITIES_FETCH */.g.ACTIVITIES_FETCH);
        }
    }, [
        activities,
        loading
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    if (error) {
        errorLog({
            msg: "Failed to load activities"
        }, error, types/* LogEvent.ACTIVITIES_FETCH_FAILED */.g.ACTIVITIES_FETCH_FAILED);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.loading_error"),
            onRetry: refetch
        });
    }
    var waitingForNewActivities = (0,lodash.isNil)(currentActivity);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityContext.Provider, {
        value: {
            currentActivity: currentActivity,
            waitingForNewActivities: waitingForNewActivities
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Activities/context/index.ts



;// CONCATENATED MODULE: ./src/components/Activities/hooks/useCurrentActivity.ts


var useCurrentActivity = function() {
    return (0,react.useContext)(ActivityContext);
};

;// CONCATENATED MODULE: ./src/components/Activities/hooks/index.ts


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/hooks/useMessage/types.ts


// EXTERNAL MODULE: ./node_modules/graphql/error/GraphQLError.mjs + 4 modules
var GraphQLError = __webpack_require__(3896);
;// CONCATENATED MODULE: ./src/hooks/useMessage/useMessage.ts











var useMessage = function(activity) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activity.id, _object = activity.object, message_id = _object.id;
    var ref = (0,_sliced_to_array/* default */.Z)((0,types_orchestration/* useMarkMessageAsReadMutation */.H3)(), 1), markMessageAsRead = ref[0];
    var ref1 = (0,useLogging/* useLogging */.K)(), infoLog = ref1.infoLog, errorLog = ref1.errorLog;
    var variables = {
        id: message_id
    };
    var ref2 = (0,types_orchestration/* useGetMessageQuery */.YD)({
        variables: variables,
        onError: function(error) {
            (0,esm_exports/* captureException */.Tb)(error, {
                contexts: {
                    message: {
                        message_id: message_id
                    },
                    activity: (0,_object_spread/* default */.Z)({}, activity),
                    graphql: {
                        query: "GetMessage",
                        variables: JSON.stringify(variables)
                    }
                }
            });
            GraphQLError/* GraphQLError */.__;
        }
    }), data = ref2.data, loading = ref2.loading, error = ref2.error, refetch = ref2.refetch;
    var onRead = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var markMessageAsReadVariables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        markMessageAsReadVariables = {
                            input: {
                                activity_id: activity_id
                            }
                        };
                        infoLog({
                            msg: "Trying to mark message as read",
                            activity: activity
                        }, types/* LogEvent.MESSAGE_MARKING_AS_READ */.g.MESSAGE_MARKING_AS_READ);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return markMessageAsRead({
                            variables: markMessageAsReadVariables
                        });
                    case 5:
                        infoLog({
                            msg: "Message marked as read successfully",
                            activity: activity
                        }, types/* LogEvent.MESSAGE_MARKED_AS_READ */.g.MESSAGE_MARKED_AS_READ);
                        _ctx.next = 13;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        errorLog({
                            msg: "Failed to mark message as read",
                            activity: activity
                        }, _ctx.t0, types/* LogEvent.MESSAGE_MARKING_AS_READ_FAILED */.g.MESSAGE_MARKING_AS_READ_FAILED);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.message.toast_mark_as_read_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                graphql: {
                                    query: "MarkMessageAsRead",
                                    variables: JSON.stringify(markMessageAsReadVariables)
                                }
                            }
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function onRead() {
            return _ref.apply(this, arguments);
        };
    }();
    if (loading) {
        return {
            loading: loading,
            onRead: onRead
        };
    }
    if (error) {
        return {
            error: error.message,
            loading: false,
            onRead: onRead,
            refetch: refetch
        };
    }
    return {
        loading: loading,
        message: data === null || data === void 0 ? void 0 : data.message.message,
        onRead: onRead,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useMessage/index.ts



// EXTERNAL MODULE: ./src/assets/link.svg
var assets_link = __webpack_require__(4311);
var link_default = /*#__PURE__*/__webpack_require__.n(assets_link);
;// CONCATENATED MODULE: ./src/components/Message/Message.tsx













var Message = function(param) {
    var activity = param.activity;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,useHostedSession/* useHostedSession */.H)().theme;
    var ref = useMessage(activity), loading = ref.loading, message = ref.message, error = ref.error, onRead = ref.onRead, refetch = ref.refetch;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    if (error || !message) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.message.loading_error"),
            onRetry: refetch
        });
    }
    var handleReadMessage = function() {
        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.READ_MESSAGE */.j.READ_MESSAGE,
            data: {
                message: message === null || message === void 0 ? void 0 : message.id
            }
        });
        onRead();
    };
    var _subject;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Message, {
        content: message.body,
        subject: (_subject = message.subject) !== null && _subject !== void 0 ? _subject : "",
        attachments: message.attachments || [],
        attachmentIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: (link_default()),
            alt: "",
            width: 20,
            height: 20
        }),
        attachmentLabels: {
            video: t("activities.message.open_video_attachment"),
            link: t("activities.message.open_link_attachment"),
            file: t("activities.message.download_file_attachment")
        },
        onMessageRead: handleReadMessage,
        buttonLabels: {
            readMessage: (0,lodash.isEmpty)(theme.locales.message.cta_mark_as_read) ? t("activities.message.cta_mark_as_read") : theme.locales.message.cta_mark_as_read
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Message/index.ts


;// CONCATENATED MODULE: ./src/hooks/useChecklist/types.ts


;// CONCATENATED MODULE: ./src/hooks/useChecklist/useChecklist.ts



var useChecklist = function(activity) {
    var _object = activity.object, checklist_id = _object.id;
    var variables = {
        id: checklist_id
    };
    var ref = (0,types_orchestration/* useGetChecklistQuery */.DX)({
        variables: variables,
        onError: function(error) {
            (0,esm_exports/* captureException */.Tb)(error, {
                contexts: {
                    checklist: {
                        checklist_id: checklist_id
                    },
                    activity: (0,_object_spread/* default */.Z)({}, activity),
                    graphql: {
                        query: "GetChecklist",
                        variables: JSON.stringify(variables)
                    }
                }
            });
        }
    }), data = ref.data, loading = ref.loading, error = ref.error, refetch = ref.refetch;
    if (loading) {
        return {
            loading: loading
        };
    }
    if (error) {
        return {
            loading: false,
            error: error.message,
            refetch: refetch
        };
    }
    // @ts-expect-error
    var ref1 = data === null || data === void 0 ? void 0 : data.checklist.checklist, _items = ref1.items, items = _items === void 0 ? [] : _items, _title = ref1.title, title = _title === void 0 ? "" : _title;
    var formatted_items = items.map(function(item, index) {
        return {
            id: index.toString(),
            label: item
        };
    });
    return {
        loading: loading,
        title: title,
        items: formatted_items,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useChecklist/index.ts


;// CONCATENATED MODULE: ./src/hooks/useSubmitChecklist/types.ts


;// CONCATENATED MODULE: ./src/hooks/useSubmitChecklist/useSubmitChecklist.ts










var useSubmitChecklist = function(activity) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activity.id;
    var ref = (0,_sliced_to_array/* default */.Z)((0,types_orchestration/* useSubmitChecklistMutation */.oA)(), 1), submitChecklist = ref[0];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var ref2 = (0,useLogging/* useLogging */.K)(), infoLog = ref2.infoLog, errorLog = ref2.errorLog;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var variables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        variables = {
                            input: {
                                activity_id: activity_id
                            }
                        };
                        infoLog({
                            activity: activity,
                            variables: variables
                        }, types/* LogEvent.CHECKLIST_SUBMITTING */.g.CHECKLIST_SUBMITTING);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return submitChecklist({
                            variables: variables
                        });
                    case 6:
                        infoLog({
                            activity: activity
                        }, types/* LogEvent.CHECKLIST_SUBMITTED */.g.CHECKLIST_SUBMITTED);
                        _ctx.next = 15;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        errorLog({
                            activity: activity,
                            variables: variables
                        }, _ctx.t0, types/* LogEvent.CHECKLIST_SUBMITTING_FAILED */.g.CHECKLIST_SUBMITTING_FAILED);
                        setIsSubmitting(false);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.checklist.saving_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                activity: activity,
                                graphql: {
                                    query: "SubmitChecklist",
                                    variables: JSON.stringify(variables)
                                }
                            }
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onSubmit: onSubmit,
        isSubmitting: isSubmitting
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSubmitChecklist/index.ts


;// CONCATENATED MODULE: ./src/components/Checklist/Checklist.tsx












var Checklist = function(param) {
    var activity = param.activity;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,useHostedSession/* useHostedSession */.H)().theme;
    var ref = useChecklist(activity), loading = ref.loading, items = ref.items, title = ref.title, error = ref.error, refetch = ref.refetch;
    var ref1 = useSubmitChecklist(activity), onSubmit = ref1.onSubmit, isSubmitting = ref1.isSubmitting;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.checklist.loading_error", {
                error: error
            }),
            onRetry: refetch
        });
    }
    var handleSubmit = function() {
        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.SUBMIT_CHECKLIST */.j.SUBMIT_CHECKLIST,
            data: {
                checklist_id: activity.object.id
            }
        });
        onSubmit();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Checklist, {
        title: title || "",
        items: items || [],
        onSubmit: handleSubmit,
        disabled: isSubmitting,
        submitLabel: (0,lodash.isEmpty)(theme.locales.checklist.cta_submit) ? t("activities.checklist.cta_submit") : theme.locales.checklist.cta_submit
    });
};
Checklist.displayName = "Checklist";

;// CONCATENATED MODULE: ./src/components/Checklist/index.ts


// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7573);
;// CONCATENATED MODULE: ./src/components/Extension/utils.ts



var mapActionFieldsToObject = function(fields) {
    return fields.reduce(function(previousValue, currentValue) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousValue), (0,_define_property/* default */.Z)({}, currentValue.id, currentValue.value));
    }, {});
};
var mapSettingsToObject = function(settings) {
    return settings === null || settings === void 0 ? void 0 : settings.reduce(function(previousValue, currentValue) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousValue), (0,_define_property/* default */.Z)({}, currentValue.key, currentValue.value));
    }, {});
};

;// CONCATENATED MODULE: ./src/hooks/useCompleteExtensionActivity/types.ts


;// CONCATENATED MODULE: ./src/hooks/useCompleteExtensionActivity/useCompleteExtensionActivity.ts








var useCompleteExtensionActivity = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,types_orchestration/* useCompleteExtensionActivityMutation */.Pp)(), 1), completeExtensionActivity = ref1[0];
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activity_id, data_points) {
            var variables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        variables = {
                            input: {
                                activity_id: activity_id,
                                data_points: data_points
                            }
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return completeExtensionActivity({
                            variables: variables
                        });
                    case 5:
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](2);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.checklist.saving_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                activity: {
                                    activity_id: activity_id
                                },
                                graphql: {
                                    query: "CompleteExtensionActivity",
                                    variables: JSON.stringify(variables)
                                }
                            }
                        });
                    case 11:
                        _ctx.prev = 11;
                        setIsSubmitting(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    7,
                    11,
                    14
                ]
            ]);
        }));
        return function(activity_id, data_points) {
            return _ref.apply(this, arguments);
        };
    }(), [
        completeExtensionActivity,
        t
    ]);
    return {
        onSubmit: onSubmit,
        isSubmitting: isSubmitting
    };
};

;// CONCATENATED MODULE: ./src/hooks/useCompleteExtensionActivity/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/types.ts

var ActionKey;
(function(ActionKey) {
    ActionKey["BOOK_APPOINTMENT"] = "bookAppointment";
})(ActionKey || (ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/useCompleteBookAppointment.ts




var useCompleteBookAppointment = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, data) {
            var ref, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        dataPoints = [
                            {
                                key: "bookingId",
                                value: "".concat(data === null || data === void 0 ? void 0 : (ref = data.booking) === null || ref === void 0 ? void 0 : ref.id)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/BookAppointmentAction.tsx





var BookAppointmentAction = function(param) {
    var activityDetails = param.activityDetails;
    var ref = (0,dist.useTheme)(), updateLayoutMode = ref.updateLayoutMode, resetLayoutMode = ref.resetLayoutMode;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, pathway_id = activityDetails.pathway_id;
    var onSubmit = useCompleteBookAppointment().onSubmit;
    var calLink = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).calLink;
    var onBookingSuccessful = (0,react.useCallback)(function(data) {
        onSubmit(activity_id, data);
    }, [
        activity_id,
        onSubmit
    ]);
    (0,react.useEffect)(function() {
        updateLayoutMode("flexible");
        return function() {
            // Reset to default mode on unmount
            resetLayoutMode();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CalDotComScheduling, {
        calLink: calLink,
        metadata: {
            awellPathwayId: pathway_id,
            awellActivityId: activity_id
        },
        onBookingSuccessful: onBookingSuccessful
    });
};
BookAppointmentAction.displayName = "BookAppointmentAction";

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/CalDotComExtension.tsx






var CalDotComExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case ActionKey.BOOK_APPOINTMENT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BookAppointmentAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
CalDotComExtension.displayName = "CalDotComExtension";

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/index.ts


// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(6793);
;// CONCATENATED MODULE: ./src/hooks/useExtensionActivity/types.ts


;// CONCATENATED MODULE: ./src/hooks/useExtensionActivity/useExtensionActivity.ts




var useExtensionActivity = function(id) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,types_orchestration/* useGetExtensionActivityDetailsQuery */.im)({
        variables: {
            id: id
        },
        nextFetchPolicy: "cache-first"
    }), data = ref.data, loading = ref.loading, error = ref.error, refetch = ref.refetch;
    (0,react.useEffect)(function() {
        void refetch();
    }, [
        id
    ]);
    if (!(0,lodash.isNil)(error)) {
        return {
            loading: false,
            error: error.message,
            refetch: refetch
        };
    }
    if (loading) {
        return {
            loading: true
        };
    }
    return {
        loading: false,
        extensionActivityDetails: data === null || data === void 0 ? void 0 : data.extensionActivityRecord.record,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useExtensionActivity/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/types.ts
var ExtensionKey;
(function(ExtensionKey) {
    ExtensionKey["CAL_DOT_COM"] = "calDotCom";
    ExtensionKey["FORMSORT"] = "formsort";
    ExtensionKey["DROPBOXSIGN"] = "dropboxSign";
    ExtensionKey["CLOUDINARY"] = "cloudinary";
    ExtensionKey["DOCU_SIGN"] = "docuSign";
    ExtensionKey["COLLECT_DATA"] = "collectData";
    ExtensionKey["EXPERIMENTAL"] = "experimental";
    ExtensionKey["STRIPE"] = "stripe";
    ExtensionKey["IDENTITY_VERIFICATION"] = "identityVerification";
})(ExtensionKey || (ExtensionKey = {}));
var AnonymousActionKeys;
(function(AnonymousActionKeys) {
    AnonymousActionKeys["COLLECT_MEDICATION"] = "collectMedication";
    AnonymousActionKeys["PATIENT_RECOMMENDATION"] = "patientRecommendation";
    AnonymousActionKeys["REDIRECT"] = "redirect";
    AnonymousActionKeys["INTAKE_SCHEDULING"] = "intakeScheduling";
})(AnonymousActionKeys || (AnonymousActionKeys = {}));

// EXTERNAL MODULE: ./node_modules/@formsort/react-embed/lib/index.js
var lib = __webpack_require__(4914);
// EXTERNAL MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/completeFlowAction.module.css
var completeFlowAction_module = __webpack_require__(4612);
var completeFlowAction_module_default = /*#__PURE__*/__webpack_require__.n(completeFlowAction_module);
;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/types.ts

var types_ActionKey;
(function(ActionKey) {
    ActionKey["COMPLETE_FLOW"] = "completeFlow";
})(types_ActionKey || (types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/hooks/useCompleteCompleteFlowAction.tsx




var useCompleteCompleteFlowAppointment = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId) {
            var dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataPoints = [];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/CompleteFlowAction.tsx






var CompleteFlowAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings;
    var onSubmit = useCompleteCompleteFlowAppointment().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), clientLabel = ref.clientLabel, flowLabel = ref.flowLabel, variantLabel = ref.variantLabel;
    var environment = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        fields
    ]).environment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (completeFlowAction_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
            clientLabel: clientLabel,
            flowLabel: flowLabel,
            variantLabel: variantLabel,
            formsortEnv: environment,
            embedConfig: {
                style: {
                    width: "100%",
                    height: "100%"
                }
            },
            onFlowFinalized: function(answers) {
                onSubmit(activity_id);
            }
        })
    });
};
CompleteFlowAction.displayName = "CompleteFlowAction";

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/FormsortExtension.tsx






var FormsortExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case types_ActionKey.COMPLETE_FLOW:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteFlowAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
FormsortExtension.displayName = "FormsortExtension";

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/index.tsx


// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var zod_lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/types.ts



var DropboxSignExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["EMBEDDED_SIGNING"] = "embeddedSigning";
})(DropboxSignExtension_types_ActionKey || (DropboxSignExtension_types_ActionKey = {}));
var SettingsValidationSchema = zod_lib.z.object({
    clientId: zod_lib.z.string(),
    testMode: zod_lib.z.optional(zod_lib.z["enum"]([
        "Yes",
        "No",
        "yes",
        "no"
    ])).transform(function(testMode) {
        if ((0,lodash.isEmpty)(testMode) || (0,lodash.isNil)(testMode)) return false;
        var serializedTestmode = (0,lodash.lowerCase)(testMode);
        if (serializedTestmode === "yes") return true;
        return false;
    })
});
var validateSettings = function(settings) {
    var parsedData = SettingsValidationSchema.parse(settings);
    return parsedData;
};

;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/EmbeddedSigningAction/hooks/useCompleteEmbeddedSigningAction.tsx




var useCompleteEmbeddedSigningAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, param) {
            var signed, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        signed = param.signed;
                        dataPoints = [
                            {
                                key: "signed",
                                value: String(signed)
                            }
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, _) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js + 2 modules
var isAfter = __webpack_require__(4966);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(6492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/EmbeddedSigningAction/EmbeddedSigningAction.tsx








var EmbeddedSigningAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings;
    var onSubmit = useCompleteEmbeddedSigningAction().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), signUrl = ref.signUrl, expiresAt = ref.expiresAt;
    /**
   * This is needed because Orchestration seems to encode string action field values
   * - Data point value: https://url.com/?signature_id=ABC&token=DEF
   * - Action field value https://url.com/?signature_id&#x3D;ABC&amp;token&#x3D;DEF
   *
   * We need the decoded action field value and he library helps us to force decode
   * the url to a valid one.
   */ var decodedSignUrl = he_default().decode(signUrl);
    var settingsData = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        settings
    ]);
    var ref1 = validateSettings(settingsData), testMode = ref1.testMode, clientId = ref1.clientId;
    /**
   * https://github.com/vercel/next.js/issues/35559
   */ var singDocument = function() {
        Promise.all(/* import() */[__webpack_require__.e(117), __webpack_require__.e(507)]).then(__webpack_require__.t.bind(__webpack_require__, 507, 23)).then(function(param) {
            var HelloSign = param.default;
            return new HelloSign({
                clientId: clientId
            });
        }).then(function(client) {
            client.open(decodedSignUrl, {
                allowCancel: true,
                testMode: testMode,
                debug: testMode,
                skipDomainVerification: true
            });
            /*
         ! Needs handling of all events; currently only `sign` event is handled
         ! https://github.com/hellosign/hellosign-embedded/wiki/API-Documentation-(v2)#events
         */ client.on("sign", function() {
                onSubmit(activity_id, {
                    signed: true
                });
            });
        });
    };
    var isSignUrlExpired = (0,isAfter/* default */.Z)(new Date(), new Date(expiresAt));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            padding: "12px 0 0 0"
        },
        children: isSignUrlExpired ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "The sign URL for this signature request is expired."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                    onClick: function() {
                        return onSubmit(activity_id, {
                            signed: false
                        });
                    },
                    children: "Continue"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
            onClick: singDocument,
            children: "Sign document"
        })
    });
};
EmbeddedSigningAction.displayName = "EmbeddedSigningAction";

;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/EmbeddedSigningAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/DropboxSignExtension.tsx






var DropboxSignExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case DropboxSignExtension_types_ActionKey.EMBEDDED_SIGNING:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedSigningAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
DropboxSignExtension.displayName = "DropboxSignExtension";

;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/types.ts

var CloudinaryExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["UPLOAD_FILES"] = "uploadFiles";
    ActionKey["UPLOAD_SINGLE_FILE"] = "uploadSingleFile";
})(CloudinaryExtension_types_ActionKey || (CloudinaryExtension_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadFilesAction/hooks/useCompleteUploadFilesAction.tsx




var useCompleteUploadFilesAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, fileUrls) {
            var dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataPoints = [];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, fileUrls) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadFilesAction/UploadFilesAction.tsx









var UploadFilesAction = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings, pathway_id = activityDetails.pathway_id;
    var onSubmit = useCompleteUploadFilesAction().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        settings
    ]), cloudName = ref.cloudName, uploadPresetSettings = ref.uploadPreset, folderSettings = ref.folder;
    var ref1 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), uploadPresetActionFields = ref1.uploadPreset, folderActionFields = ref1.folder, tags = ref1.tags;
    var ref2;
    var tagsArray = (0,react.useMemo)(function() {
        return (ref2 = tags === null || tags === void 0 ? void 0 : tags.split(",")) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        tags
    ]);
    var onSave = (0,react.useCallback)(function(files) {
        onSubmit(activity_id, files.map(function(file) {
            return file.url;
        }));
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CloudinaryUpload, {
        cloudName: cloudName,
        uploadPreset: !(0,lodash.isEmpty)(uploadPresetActionFields) && !(0,lodash.isNil)(uploadPresetActionFields) ? uploadPresetActionFields : uploadPresetSettings,
        folder: folderActionFields !== null && folderActionFields !== void 0 ? folderActionFields : folderSettings,
        tags: tagsArray,
        context: {
            awellPathwayId: pathway_id,
            awellActivityId: activity_id
        },
        onFinish: onSave,
        text: {
            subject: t("activities.cloudinary.subject"),
            attachmentIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (link_default()),
                alt: "",
                width: 20,
                height: 20
            }),
            attachmentLabels: {
                file: t("activities.cloudinary.file_attachment"),
                video: t("activities.cloudinary.video_attachment"),
                link: t("activities.cloudinary.link_attachment")
            },
            fileCountHeader: function(count) {
                if (count === 1) return t("activities.cloudinary.file_count_one");
                if (count > 1) return t("activities.cloudinary.file_count_other", {
                    count: count
                });
                return t("activities.cloudinary.file_count_zero");
            },
            buttonLabels: {
                upload: t("activities.cloudinary.cta_upload_files"),
                done: t("activities.cta_done")
            }
        }
    });
};
UploadFilesAction.displayName = "UploadFilesAction";

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadFilesAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadSingleFileAction/hooks/useCompleteSingleUploadFileAction.tsx




var useCompleteSingleUploadFileAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, fileUrl) {
            var dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataPoints = [
                            {
                                key: "fileUrl",
                                value: String(fileUrl)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, fileUrl) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadSingleFileAction/UploadSingleFileAction.tsx









var UploadSingleFileAction = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings, pathway_id = activityDetails.pathway_id;
    var onSubmit = useCompleteSingleUploadFileAction().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        settings
    ]), cloudName = ref.cloudName, uploadPresetSettings = ref.uploadPreset, folderSettings = ref.folder;
    var ref1 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), uploadPresetActionFields = ref1.uploadPreset, folderActionFields = ref1.folder, tags = ref1.tags;
    var ref2;
    var tagsArray = (0,react.useMemo)(function() {
        return (ref2 = tags === null || tags === void 0 ? void 0 : tags.split(",")) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        tags
    ]);
    var onSave = (0,react.useCallback)(function(file) {
        onSubmit(activity_id, String(file === null || file === void 0 ? void 0 : file.url));
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CloudinarySingleFileUpload, {
        cloudName: cloudName,
        uploadPreset: !(0,lodash.isEmpty)(uploadPresetActionFields) && !(0,lodash.isNil)(uploadPresetActionFields) ? uploadPresetActionFields : uploadPresetSettings,
        folder: folderActionFields !== null && folderActionFields !== void 0 ? folderActionFields : folderSettings,
        tags: tagsArray,
        context: {
            awellPathwayId: pathway_id,
            awellActivityId: activity_id
        },
        onFinish: onSave,
        text: {
            subject: t("activities.cloudinary.single_file_upload_action.subject_single_file_upload"),
            attachmentIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (link_default()),
                alt: "",
                width: 20,
                height: 20
            }),
            attachmentLabels: {
                file: t("activities.cloudinary.file_attachment"),
                video: t("activities.cloudinary.video_attachment"),
                link: t("activities.cloudinary.link_attachment")
            },
            fileCountHeader: function(fileUploaded) {
                return fileUploaded ? t("activities.cloudinary.single_file_upload_action.file_uploaded") : t("activities.cloudinary.single_file_upload_action.no_file_uploaded");
            },
            buttonLabels: {
                upload: t("activities.cloudinary.single_file_upload_action.cta_upload_file"),
                done: t("activities.cta_done")
            }
        }
    });
};
UploadSingleFileAction.displayName = "UploadSingleFileAction";

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadSingleFileAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/index.tsx



;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/CloudinaryExtension.tsx






var CloudinaryExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case CloudinaryExtension_types_ActionKey.UPLOAD_FILES:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadFilesAction, {
                activityDetails: activityDetails
            });
        case CloudinaryExtension_types_ActionKey.UPLOAD_SINGLE_FILE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadSingleFileAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
CloudinaryExtension.displayName = "CloudinaryExtension";

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/index.tsx


// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(7563);
;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/types.ts

var DocuSignExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["EMBEDDED_SIGNING"] = "embeddedSigning";
})(DocuSignExtension_types_ActionKey || (DocuSignExtension_types_ActionKey = {}));
var WindowEventType;
(function(WindowEventType) {
    WindowEventType["DOCU_SIGN_SET_EVENT"] = "docu_sign_set_event";
})(WindowEventType || (WindowEventType = {}));
var DocuSignEvent;
(function(DocuSignEvent) {
    DocuSignEvent[// Recipient used incorrect access code.
    "ACCESS_CODE_FAILED"] = "access_code_failed";
    DocuSignEvent[// Recipient canceled the signing operation, possibly by using the Finish Later option.
    "CANCEL"] = "cancel";
    DocuSignEvent[// Recipient declined to sign.
    "DECLINE"] = "decline";
    DocuSignEvent[// A system error occurred during the signing process.
    "EXCEPTION"] = "exception";
    DocuSignEvent[// Recipient has a fax pending.
    "FAX_PENDING"] = "fax_pending";
    DocuSignEvent[// Recipient failed an ID check.
    "ID_CHECK_FAILED"] = "id_check_failed";
    DocuSignEvent[// The session timed out. An account can control this timeout by using the Signer Session Timeout option.
    "SESSION_TIMEOUT"] = "session_timeout";
    DocuSignEvent[// The recipient completed the signing ceremony.
    "SIGNING_COMPLETE"] = "signing_complete";
    DocuSignEvent[// The Time To Live token for the envelope has expired. After being successfully invoked, these tokens expire after five minutes.
    "TTL_EXPIRED"] = "ttl_expired";
    DocuSignEvent[// The recipient completed viewing an envelope that is in a read-only/terminal state, such as completed, declined, or voided.
    "VIEWING_COMPLETE"] = "viewing_complete";
})(DocuSignEvent || (DocuSignEvent = {}));

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/hooks/useCompleteEmbeddedSigningAction.tsx




var useCompleteEmbeddedSigningAction_useCompleteEmbeddedSigningAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, param) {
            var signed, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        signed = param.signed;
                        dataPoints = [
                            {
                                key: "signed",
                                value: String(signed)
                            }
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, _) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/IFrameMessager.tsx



var IFrameMessager = function(param) {
    var iframeEvent = param.iframeEvent, setEvent = param.setEvent;
    var isIframe = !!iframeEvent;
    var handleDocuSignEvent = (0,react.useCallback)(function(event) {
        var ref;
        // validate domain
        if (event.origin !== location.origin) {
            return;
        }
        switch((ref = event.data) === null || ref === void 0 ? void 0 : ref.type){
            case WindowEventType.DOCU_SIGN_SET_EVENT:
                setEvent(event.data.event);
                break;
            default:
                break;
        }
    }, [
        setEvent
    ]);
    (0,react.useEffect)(function() {
        if (isIframe) {
            var ref;
            (ref = window.top) === null || ref === void 0 ? void 0 : ref.postMessage({
                event: iframeEvent,
                type: WindowEventType.DOCU_SIGN_SET_EVENT
            }, location.origin);
        } else {
            window.addEventListener("message", handleDocuSignEvent, false);
            return function() {
                window.removeEventListener("message", handleDocuSignEvent, false);
            };
        }
    }, [
        handleDocuSignEvent,
        iframeEvent,
        isIframe
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
IFrameMessager.displayName = "IFrameMessager";

// EXTERNAL MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/embeddedSigning.module.css
var embeddedSigning_module = __webpack_require__(1397);
var embeddedSigning_module_default = /*#__PURE__*/__webpack_require__.n(embeddedSigning_module);
;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/SigningProcess.tsx






var SigningProcess = function(param) {
    var signUrl = param.signUrl, isIframeLoaded = param.isIframeLoaded, setIsIframeLoaded = param.setIsIframeLoaded;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isSignProcess = ref[0], setIsSignProcess = ref[1];
    var beginSigning = function() {
        setIsSignProcess(true);
    };
    if (isSignProcess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !isIframeLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: isIframeLoaded ? (embeddedSigning_module_default())["iframe-loaded"] : (embeddedSigning_module_default())["iframe-loading"],
                    src: signUrl,
                    onLoad: function() {
                        setIsIframeLoaded(true);
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
            onClick: beginSigning,
            children: t("activities.docu_sign.cta_sign_document")
        })
    });
};
SigningProcess.displayName = "SigningProcess";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/FinishedMessage.tsx






var FinishedMessage = function(param) {
    var event = param.event, finishSigning = param.finishSigning;
    var t = (0,esm/* useTranslation */.$G)().t;
    var finishAndFailSigning = function() {
        finishSigning({
            signed: false
        });
    };
    switch(event){
        case DocuSignEvent.SIGNING_COMPLETE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
        case DocuSignEvent.TTL_EXPIRED:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: t("activities.docu_sign.expired_sign_document")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            onClick: finishAndFailSigning,
                            children: t("activities.cta_done")
                        })
                    ]
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: t("activities.docu_sign.failed_sign_document")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            onClick: finishAndFailSigning,
                            children: t("activities.cta_done")
                        })
                    ]
                })
            });
    }
};
FinishedMessage.displayName = "FinishedMessage";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/EmbeddedSigningAction.tsx











var EmbeddedSigningAction_EmbeddedSigningAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = useCompleteEmbeddedSigningAction_useCompleteEmbeddedSigningAction().onSubmit;
    var ref;
    // visible in IFrame only
    var ref1 = (ref = (0,query_string.parse)(location.search)) !== null && ref !== void 0 ? ref : {}, iframeEvent = ref1.event;
    var ref2 = (0,react.useState)(false), isIframeLoaded = ref2[0], setIsIframeLoaded = ref2[1];
    var ref3 = (0,react.useState)(undefined), event = ref3[0], setEvent = ref3[1];
    var isFinished = !!event;
    var isIframe = !!iframeEvent;
    var signUrl = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).signUrl;
    /**
   * This is needed because Orchestration seems to encode string action field values
   * - Data point value: https://url.com/?signature_id=ABC&token=DEF
   * - Action field value https://url.com/?signature_id&#x3D;ABC&amp;token&#x3D;DEF
   *
   * We need the decoded action field value and he library helps us to force decode
   * the url to a valid one.
   */ var decodedSignUrl = he_default().decode(signUrl);
    var finishSigning = (0,react.useCallback)(function(param) {
        var signed = param.signed;
        onSubmit(activity_id, {
            signed: signed
        });
    }, [
        activity_id,
        onSubmit
    ]);
    (0,react.useEffect)(function() {
        if (isFinished) {
            setIsIframeLoaded(false);
            if (event === DocuSignEvent.SIGNING_COMPLETE) {
                finishSigning({
                    signed: true
                });
            }
        }
    }, [
        event,
        finishSigning,
        isFinished
    ]);
    // this window is iframe content -> render only messager
    if (isIframe) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameMessager, {
            iframeEvent: iframeEvent,
            setEvent: setEvent
        });
    }
    // this window is extension content -> render messager and extension
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameMessager, {
                iframeEvent: iframeEvent,
                setEvent: setEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // if iframe is loaded -> fill screen
                className: "".concat((embeddedSigning_module_default()).wrapper, " ").concat(isIframeLoaded ? (embeddedSigning_module_default())["flex-full"] : ""),
                children: isFinished ? // signing process is finished -> display messsage
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishedMessage, {
                    event: event,
                    finishSigning: finishSigning
                }) : // signing process incomplete (or user refreshed page) -> display signing process
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SigningProcess, {
                    signUrl: decodedSignUrl,
                    isIframeLoaded: isIframeLoaded,
                    setIsIframeLoaded: setIsIframeLoaded
                })
            })
        ]
    });
};
EmbeddedSigningAction_EmbeddedSigningAction.displayName = "EmbeddedSigningAction";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/DocuSignExtension.tsx






var DocuSignExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case DocuSignExtension_types_ActionKey.EMBEDDED_SIGNING:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedSigningAction_EmbeddedSigningAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
DocuSignExtension.displayName = "DropboxSignExtension";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/index.tsx


// EXTERNAL MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/remoteSingleSelectAction.module.css
var remoteSingleSelectAction_module = __webpack_require__(7640);
var remoteSingleSelectAction_module_default = /*#__PURE__*/__webpack_require__.n(remoteSingleSelectAction_module);
;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/types.ts

var CollectDataExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["REMOTE_SINGLE_SELECT"] = "remoteSingleSelect";
    ActionKey["COLLECT_MEDICATION"] = "collectMedication";
})(CollectDataExtension_types_ActionKey || (CollectDataExtension_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/hooks/useRemoteSingleSelectAction.tsx




var useRemoteSingleSelectAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, label, value, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, label = param.label, value = param.value;
                        dataPoints = [
                            {
                                key: "label",
                                value: String(label)
                            },
                            {
                                key: "value",
                                value: String(value)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/RemoteSingleSelectAction.tsx











var RemoteSingleSelectAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useRemoteSingleSelectAction(), onSubmit = ref.onSubmit, isSubmitting = ref.isSubmitting;
    var ref1 = (0,react.useState)(), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var ref2 = (0,react.useState)([]), options = ref2[0], setOptions = ref2[1];
    var ref3 = (0,react.useState)(), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(""), searchText = ref4[0], setSearchText = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var generateUrl = function(url, queryParam) {
        var search = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        return !(0,lodash.isNil)(queryParam) && search !== "" ? "".concat(url, "?").concat(queryParam, "=").concat(search) : url;
    };
    var handleFetchOptions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url, queryParam, headers) {
            var search, onError, response, options, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        search = _args.length > 3 && _args[3] !== void 0 ? _args[3] : "", onError = _args.length > 4 ? _args[4] : void 0;
                        _ctx.prev = 1;
                        setLoading(true);
                        _ctx.next = 5;
                        return fetch(generateUrl(url, queryParam, search), {
                            method: "GET",
                            headers: (0,_object_spread/* default */.Z)({
                                "Content-Type": "application/json"
                            }, JSON.parse(headers))
                        });
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        options = _ctx.sent;
                        if (!(0,lodash.isNil)(onError)) {
                            onError(undefined);
                        }
                        return _ctx.abrupt("return", options);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,lodash.isNil)(onError)) {
                            onError(_ctx.t0);
                        }
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13,
                    16,
                    19
                ]
            ]);
        }));
        return function handleFetchOptions(url, queryParam, headers) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), queryParam = ref6.queryParam, url = ref6.url, label = ref6.label, _headers = ref6.headers, headers = _headers === void 0 ? "{}" : _headers, mandatory = ref6.mandatory;
    var fetchOptionsDebounced = (0,lodash.debounce)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var options;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return handleFetchOptions(url, queryParam, headers, searchText, setError);
                case 2:
                    options = _ctx.sent;
                    setOptions(options);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), 500);
    var handleSubmit = function() {
        if ((0,lodash.isNil)(selectedOption) || (0,lodash.isNil)(selectedOption.value)) {
            setError(t("activities.form.question_required_error"));
            return;
        }
        onSubmit({
            activityId: activity_id,
            label: selectedOption.label,
            value: selectedOption.value.toString()
        });
    };
    (0,react.useEffect)(function() {
        fetchOptionsDebounced();
    }, [
        searchText
    ]);
    if (!activityDetails || !activityDetails.fields || !options) {
        return null;
    }
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (remoteSingleSelectAction_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (remoteSingleSelectAction_module_default()).selectContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                        id: "select",
                        labels: {
                            questionLabel: label,
                            noOptions: t("activities.form.questions.select.no_options"),
                            placeholder: t("activities.form.questions.select.type_to_search"),
                            loading: t("activities.form.questions.select.loading")
                        },
                        loading: loading,
                        options: options,
                        onSearch: function(value) {
                            setSearchText(value);
                        },
                        type: "single",
                        value: (ref7 = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== null && ref7 !== void 0 ? ref7 : "",
                        onChange: function(value) {
                            var selectedOption = options.find(function(option) {
                                return option.value.toString() === value.toString();
                            });
                            setSelectedOption(selectedOption);
                        },
                        mandatory: mandatory === "true",
                        filtering: true
                    }),
                    !(0,lodash.isNil)(error) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (remoteSingleSelectAction_module_default()).error,
                        children: String(error)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (remoteSingleSelectAction_module_default()).buttonContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                    onClick: handleSubmit,
                    disabled: isSubmitting,
                    children: t("activities.form.cta_submit")
                })
            })
        ]
    });
};
RemoteSingleSelectAction.displayName = "RemoteSingleSelectAction";

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/CollectMedication/hooks/useCollectMedication.tsx




var useCollectMedication = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, medicationData, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, medicationData = param.medicationData;
                        dataPoints = [
                            {
                                key: "medicationData",
                                value: medicationData
                            },
                            {
                                key: "medicationDataString",
                                value: medicationData
                            }
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/CollectMedication/CollectMedication.tsx






var CollectMedication = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = useCollectMedication().onSubmit;
    var t = (0,esm/* useTranslation */.$G)().t;
    var label = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).label;
    var handleSubmit = (0,react.useCallback)(function(medications) {
        onSubmit({
            activityId: activity_id,
            medicationData: JSON.stringify(medications)
        });
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CollectMedication, {
        onSubmit: handleSubmit,
        label: label,
        text: {
            medication_name: t("activities.collect_medication.medication_name"),
            medication_dose: t("activities.collect_medication.medication_dose"),
            medication_instructions: t("activities.collect_medication.medication_instructions"),
            add_medication_button: t("activities.collect_medication.add_medication_button"),
            submit_medication: t("activities.collect_medication.submit_button")
        }
    });
};
CollectMedication.displayName = "CollectMedication";

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/CollectMedication/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/index.ts



;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/CollectDataExtension.tsx






var CollectDataExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case CollectDataExtension_types_ActionKey.REMOTE_SINGLE_SELECT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteSingleSelectAction, {
                activityDetails: activityDetails
            });
        case CollectDataExtension_types_ActionKey.COLLECT_MEDICATION:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectMedication, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
CollectDataExtension.displayName = "CollectDataExtension";

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/index.tsx


// EXTERNAL MODULE: ./src/components/Extension/ExperimentalExtension/actions/RequestVideoVisit/RequestVideoVisit.module.css
var RequestVideoVisit_module = __webpack_require__(5605);
var RequestVideoVisit_module_default = /*#__PURE__*/__webpack_require__.n(RequestVideoVisit_module);
;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/types.ts

var ExperimentalExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["REQUEST_VIDEO_VISIT"] = "requestVideoVisit";
    ActionKey["REDIRECT"] = "redirect";
})(ExperimentalExtension_types_ActionKey || (ExperimentalExtension_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/actions/RequestVideoVisit/hooks/useRequestVideoVisit.tsx




var useRequestVideoVisit = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, requestVideoVisit, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, requestVideoVisit = param.requestVideoVisit;
                        dataPoints = [
                            {
                                key: "requestVideoVisit",
                                value: String(requestVideoVisit)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/actions/RequestVideoVisit/RequestVideoVisit.tsx







var RequestVideoVisit = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = useRequestVideoVisit().onSubmit;
    var deepLink = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).deepLink;
    var onClick = (0,react.useCallback)(function(requestVideoVisit) {
        onSubmit({
            activityId: activity_id,
            requestVideoVisit: requestVideoVisit
        });
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RequestVideoVisit_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Whatever content we want here and full control over UI"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: !(0,lodash.isEmpty)(deepLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: deepLink || "#",
                                        title: "Deep link",
                                        children: "Test deep link"
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (RequestVideoVisit_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                        onClick: function() {
                            return onClick(false);
                        },
                        children: "Continue"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                        onClick: function() {
                            return onClick(true);
                        },
                        children: "Request video visit"
                    })
                ]
            })
        ]
    });
};
RequestVideoVisit.displayName = "RequestVideoVisit";

;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/actions/RequestVideoVisit/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/actions/index.ts


// EXTERNAL MODULE: ./src/components/Extension/SharedActions/Redirect/Redirect.module.css
var Redirect_module = __webpack_require__(3064);
var Redirect_module_default = /*#__PURE__*/__webpack_require__.n(Redirect_module);
// EXTERNAL MODULE: ./styles/ActivityLayout.module.css
var ActivityLayout_module = __webpack_require__(8936);
var ActivityLayout_module_default = /*#__PURE__*/__webpack_require__.n(ActivityLayout_module);
;// CONCATENATED MODULE: ./src/components/Extension/SharedActions/Redirect/types.ts


;// CONCATENATED MODULE: ./src/components/Extension/SharedActions/Redirect/hooks/useRedirect.tsx




var useRedirect = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId;
                        dataPoints = [];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/SharedActions/Redirect/Redirect.tsx










var Redirect = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = useRedirect().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), redirectUrl = ref.redirectUrl, redirectMessage = ref.redirectMessage;
    var handleCompletion = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return onSubmit({
                        activityId: activity_id
                    });
                case 2:
                    window.location.href = redirectUrl;
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        activity_id,
        onSubmit,
        redirectUrl
    ]);
    (0,react.useEffect)(function() {
        // If redirectMessage is empty, redirect immediately.
        var emptyHtml = '<p class="slate-p"></p>';
        if ((0,lodash.isEmpty)(redirectMessage) || redirectMessage === emptyHtml) {
            handleCompletion();
        } else {
            var SECONDS_BEFORE_REDIRECT = 2;
            var timer = setTimeout(function() {
                handleCompletion();
            }, SECONDS_BEFORE_REDIRECT * 1000);
            // Cleanup the timer if the component unmounts before the timeout is reached
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        handleCompletion,
        redirectMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            id: "ahp_main_content_with_scroll_hint",
            className: (ActivityLayout_module_default()).main_content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ActivityLayout_module_default()).container, " ").concat((Redirect_module_default()).redirect),
                children: !(0,lodash.isEmpty)(redirectMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.RichTextViewer, {
                    content: redirectMessage !== null && redirectMessage !== void 0 ? redirectMessage : ""
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Extension/SharedActions/Redirect/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/SharedActions/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/ExperimentalExtension.tsx







var ExperimentalExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case ExperimentalExtension_types_ActionKey.REQUEST_VIDEO_VISIT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestVideoVisit, {
                activityDetails: activityDetails
            });
        case ExperimentalExtension_types_ActionKey.REDIRECT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Redirect, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
ExperimentalExtension.displayName = "ExperimentalExtension";

;// CONCATENATED MODULE: ./src/components/Extension/ExperimentalExtension/index.tsx


// EXTERNAL MODULE: ./src/components/Extension/PrivateExtensions/actions/PatientRecommendation/PatientRecommendation.module.css
var PatientRecommendation_module = __webpack_require__(9710);
var PatientRecommendation_module_default = /*#__PURE__*/__webpack_require__.n(PatientRecommendation_module);
;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/EnterMedication/types.ts


;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/PatientRecommendation/hooks/usePatientRecommendation.tsx




var usePatientRecommendation = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, acceptRecommendation, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, acceptRecommendation = param.acceptRecommendation;
                        dataPoints = [
                            {
                                key: "acceptRecommendation",
                                value: String(acceptRecommendation)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/PatientRecommendation/PatientRecommendation.tsx







var PatientRecommendation = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = usePatientRecommendation().onSubmit;
    var showScrollHint = (0,dist.useScrollHint)().showScrollHint;
    var ref = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), title = ref.title, message = ref.message, acceptRecommendationButtonLabel = ref.acceptRecommendationButtonLabel, discardRecommendationButtonLabel = ref.discardRecommendationButtonLabel;
    var handleCompletion = (0,react.useCallback)(function(param) {
        var acceptRecommendation = param.acceptRecommendation;
        onSubmit({
            activityId: activity_id,
            acceptRecommendation: acceptRecommendation
        });
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "ahp_main_content_with_scroll_hint",
                className: (ActivityLayout_module_default()).main_content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "".concat((PatientRecommendation_module_default()).message, " ").concat((ActivityLayout_module_default()).container),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PatientRecommendation_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PatientRecommendation_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.RichTextViewer, {
                                content: message
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HostedPageFooter, {
                showScrollHint: showScrollHint,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((PatientRecommendation_module_default()).button_wrapper, " ").concat((ActivityLayout_module_default()).container),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            variant: "tertiary",
                            onClick: function() {
                                return handleCompletion({
                                    acceptRecommendation: false
                                });
                            },
                            children: discardRecommendationButtonLabel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            variant: "primary",
                            onClick: function() {
                                return handleCompletion({
                                    acceptRecommendation: true
                                });
                            },
                            children: acceptRecommendationButtonLabel
                        })
                    ]
                })
            })
        ]
    });
};
PatientRecommendation.displayName = "PatientRecommendation";

;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/PatientRecommendation/index.tsx


// EXTERNAL MODULE: ./src/components/Extension/PrivateExtensions/actions/EnterMedication/EnterMedication.module.css
var EnterMedication_module = __webpack_require__(5408);
var EnterMedication_module_default = /*#__PURE__*/__webpack_require__.n(EnterMedication_module);
;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/EnterMedication/hooks/useEnterMedication.tsx




var useEnterMedication = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, stringifiedMedication, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, stringifiedMedication = param.stringifiedMedication;
                        dataPoints = [
                            {
                                key: "stringifiedMedicationData",
                                value: stringifiedMedication
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/EnterMedication/EnterMedication.tsx












var EnterMedication = function(param) {
    var activityDetails = param.activityDetails;
    var ref = (0,react.useState)([]), medications = ref[0], setMedications = ref[1];
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var ref1 = (0,dist.useTheme)(), updateLayoutMode = ref1.updateLayoutMode, resetLayoutMode = ref1.resetLayoutMode;
    var onSubmit = useEnterMedication().onSubmit;
    var questionLabel = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).questionLabel;
    (0,react.useEffect)(function() {
        updateLayoutMode("flexible");
        return function() {
            // Reset to default mode on unmount
            resetLayoutMode();
        };
    }, []);
    var handleSubmit = (0,react.useCallback)(function() {
        var filteredMedications = medications.filter(function(medication) {
            return !(0,lodash.isEmpty)(medication.name) || !(0,lodash.isEmpty)(medication.dose) || !(0,lodash.isEmpty)(medication.instructions);
        });
        onSubmit({
            activityId: activity_id,
            stringifiedMedication: JSON.stringify(filteredMedications)
        });
    }, [
        activity_id,
        onSubmit,
        medications
    ]);
    var addMedication = function() {
        setMedications((0,_to_consumable_array/* default */.Z)(medications).concat([
            {
                name: "",
                dose: "",
                instructions: ""
            }
        ]));
    };
    var updateMedication = function(index, field, value) {
        var newMedications = (0,_to_consumable_array/* default */.Z)(medications);
        newMedications[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newMedications[index]), (0,_define_property/* default */.Z)({}, field, value));
        setMedications(newMedications);
    };
    var removeMedication = function(index) {
        setMedications(medications.filter(function(_, i) {
            return i !== index;
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                id: "ahp_main_content_with_scroll_hint",
                className: (ActivityLayout_module_default()).main_content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((EnterMedication_module_default()).container, " ").concat((EnterMedication_module_default()).groupMedsListContainer),
                        children: [
                            !questionLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (EnterMedication_module_default()).label,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.QuestionLabel, {
                                    label: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
                                })
                            }),
                            medications.map(function(medication, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (EnterMedication_module_default()).singleMedsListContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InputField, {
                                            id: "name",
                                            label: "Name",
                                            type: "text",
                                            value: medication.name,
                                            onChange: function(e) {
                                                return updateMedication(index, "name", e.target.value);
                                            },
                                            placeholder: "Medication Name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InputField, {
                                            id: "dose",
                                            label: "Dose",
                                            type: "text",
                                            value: medication.dose,
                                            onChange: function(e) {
                                                return updateMedication(index, "dose", e.target.value);
                                            },
                                            placeholder: "Dose"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InputField, {
                                            id: "instructions",
                                            label: "Instructions",
                                            type: "text",
                                            value: medication.instructions || "",
                                            onChange: function(e) {
                                                return updateMedication(index, "instructions", e.target.value);
                                            },
                                            placeholder: "Instructions"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                                            variant: "tertiary",
                                            onClick: function() {
                                                return removeMedication(index);
                                            },
                                            children: "X"
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((EnterMedication_module_default()).container, " ").concat((EnterMedication_module_default()).addMedsButton),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            onClick: addMedication,
                            variant: "secondary",
                            children: "Add Medication"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HostedPageFooter, {
                showScrollHint: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((ActivityLayout_module_default()).button_wrapper, " ").concat((EnterMedication_module_default()).container),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                        variant: "primary",
                        onClick: handleSubmit,
                        children: "Next"
                    })
                })
            })
        ]
    });
};
EnterMedication.displayName = "EnterMedication";

;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/EnterMedication/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/IntakeScheduling/types.ts


;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/IntakeScheduling/hooks/useIntakeScheduling.tsx




var useIntakeScheduling = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, eventId, providerId, slotDate, slotDateOnlyLocaleString, slotTimeOnlyLocaleString, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, eventId = param.eventId, providerId = param.providerId, slotDate = param.slotDate, slotDateOnlyLocaleString = param.slotDateOnlyLocaleString, slotTimeOnlyLocaleString = param.slotTimeOnlyLocaleString;
                        dataPoints = [
                            {
                                key: "eventId",
                                value: eventId
                            },
                            {
                                key: "providerId",
                                value: providerId
                            },
                            {
                                key: "slotDate",
                                value: slotDate
                            },
                            {
                                key: "slotDateOnlyLocaleString",
                                value: slotDateOnlyLocaleString
                            },
                            {
                                key: "slotTimeOnlyLocaleString",
                                value: slotTimeOnlyLocaleString
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

// EXTERNAL MODULE: ./node_modules/@awell-health/sol-scheduling/dist/index.es.js
var index_es = __webpack_require__(6317);
;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/IntakeScheduling/api.service.ts



var fetchProviders = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var response, jsonRes, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("/api/sol/providers", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(input)
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to fetch providers");
                case 6:
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    jsonRes = _ctx.sent;
                    result = index_es/* GetProvidersResponseSchema.safeParse */.L1.safeParse(jsonRes);
                    if (result.success) {
                        _ctx.next = 13;
                        break;
                    }
                    console.error("Zod parsing error", result.error.issues);
                    throw new Error("Zod error", result.error);
                case 13:
                    /**
     * Logging it the console for during the bootcamp
     */ console.log("[get providers] json response", jsonRes);
                    console.log("[get providers] parsed response with zod ", result.data);
                    return _ctx.abrupt("return", result.data);
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Error fetching providers:", _ctx.t0);
                    throw _ctx.t0;
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                18
            ]
        ]);
    }));
    return function fetchProviders(input) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAvailability = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var response, jsonRes, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("/api/sol/providers/".concat(input.providerId[0], "/availability"));
                case 3:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to fetch availability for provider ".concat(input.providerId[0]));
                case 6:
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    jsonRes = _ctx.sent;
                    result = index_es/* GetAvailabilitiesResponseSchema.safeParse */.l8.safeParse(jsonRes);
                    if (result.success) {
                        _ctx.next = 13;
                        break;
                    }
                    console.error("Zod parsing error", result.error.issues);
                    throw new Error("Zod error", result.error);
                case 13:
                    /**
     * Logging it the console for during the bootcamp
     */ console.log("[get availabilities] json response", jsonRes);
                    console.log("[get availabilities] parsed response with zod ", result.data);
                    return _ctx.abrupt("return", result.data);
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Error fetching availability for provider ".concat(input.providerId[0], ":"), _ctx.t0);
                    throw _ctx.t0;
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                18
            ]
        ]);
    }));
    return function fetchAvailability(input) {
        return _ref.apply(this, arguments);
    };
}();
var bookAppointment = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var response, jsonRes;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("/api/sol/appointments", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(input)
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to book appointment");
                case 6:
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    jsonRes = _ctx.sent;
                    /**
     * Logging it the console for during the bootcamp
     */ console.log("[book appt] json response", jsonRes);
                    return _ctx.abrupt("return", jsonRes);
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Error booking the appointment", _ctx.t0);
                    throw _ctx.t0;
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function bookAppointment(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@awell-health/sol-scheduling/dist/style.css
var style = __webpack_require__(8666);
;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/IntakeScheduling/IntakeScheduling.tsx








var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
var IntakeScheduling = function(param) {
    var activityDetails = param.activityDetails;
    var ref = (0,dist.useTheme)(), updateLayoutMode = ref.updateLayoutMode, resetLayoutMode = ref.resetLayoutMode;
    var ref1 = (0,react.useState)(undefined), provider = ref1[0], setProvider = ref1[1];
    var ref2 = (0,react.useState)(undefined), date = ref2[0], setDate = ref2[1];
    var ref3 = (0,react.useState)(undefined), slot = ref3[0], setSlot = ref3[1];
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = useIntakeScheduling().onSubmit;
    var ref4 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), providerId = ref4.providerId, patientName = ref4.patientName, agePreference = ref4.agePreference, genderPreference = ref4.genderPreference, ethnicityPreference = ref4.ethnicityPreference, clinicalFocusPreference = ref4.clinicalFocusPreference, deliveryMethodPreference = ref4.deliveryMethodPreference, locationStatePreference = ref4.locationStatePreference, therapeuticModalityPreference = ref4.therapeuticModalityPreference;
    (0,react.useEffect)(function() {
        updateLayoutMode("flexible");
        return function() {
            // Reset to default mode on unmount
            resetLayoutMode();
        };
    }, []);
    var fetchProvidersFn = (0,react.useCallback)(function() {
        return fetchProviders({
            age: agePreference ? String(agePreference) : undefined,
            gender: genderPreference,
            ethnicity: ethnicityPreference,
            therapeuticModality: therapeuticModalityPreference,
            /**
         * Although it's an array of strings,
         * we receive it as comma-separated string in hosted pages
         */ clinicalFocus: clinicalFocusPreference ? clinicalFocusPreference.split(",") : undefined,
            deliveryMethod: deliveryMethodPreference,
            location: {
                state: locationStatePreference
            }
        });
    }, [
        agePreference,
        genderPreference,
        ethnicityPreference,
        clinicalFocusPreference,
        deliveryMethodPreference,
        locationStatePreference,
        therapeuticModalityPreference, 
    ]);
    var fetchAvailabilityFn = (0,react.useCallback)(function(_providerId) {
        return fetchAvailability({
            providerId: [
                _providerId
            ]
        });
    }, []);
    var bookAppointmentFn = (0,react.useCallback)(function(_slot) {
        return bookAppointment({
            eventId: _slot.eventId,
            providerId: _slot.providerId,
            userInfo: {
                userName: patientName
            }
        });
    }, []);
    var completeActivity = (0,react.useCallback)(function(_slot) {
        onSubmit({
            activityId: activity_id,
            eventId: _slot.eventId,
            providerId: _slot.providerId,
            slotDate: _slot.slotstart.toISOString(),
            slotDateOnlyLocaleString: _slot.slotstart.toLocaleDateString(),
            slotTimeOnlyLocaleString: _slot.slotstart.toLocaleTimeString()
        });
    }, [
        activity_id,
        onSubmit,
        providerId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SchedulingActivity */.Rq, {
        providerId: providerId,
        timeZone: timeZone,
        onProviderSelect: function(id) {
            return setProvider(id);
        },
        onDateSelect: function(date) {
            return setDate(date);
        },
        onSlotSelect: function(slot) {
            return setSlot(slot);
        },
        onBooking: bookAppointmentFn,
        fetchProviders: fetchProvidersFn,
        fetchAvailability: fetchAvailabilityFn,
        onCompleteActivity: completeActivity,
        opts: {
            allowSchedulingInThePast: false
        }
    });
};
IntakeScheduling.displayName = "IntakeScheduling";

;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/IntakeScheduling/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/PrivateExtensions/actions/index.ts





// EXTERNAL MODULE: ./src/components/Extension/StripeExtension/actions/EmbeddedCheckout/EmbeddedCheckout.module.css
var EmbeddedCheckout_module = __webpack_require__(9137);
var EmbeddedCheckout_module_default = /*#__PURE__*/__webpack_require__.n(EmbeddedCheckout_module);
;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/types.ts

var StripeExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["EMBEDDED_CHECKOUT"] = "embeddedCheckout";
})(StripeExtension_types_ActionKey || (StripeExtension_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/actions/EmbeddedCheckout/hooks/useEmbeddedCheckout.tsx




var useEmbeddedCheckout = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, success, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, success = param.success;
                        dataPoints = [
                            {
                                key: "success",
                                value: String(success)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/lib/index.mjs + 1 modules
var stripe_js_lib = __webpack_require__(2859);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(6664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/actions/EmbeddedCheckout/EmbeddedCheckout.tsx









var EmbeddedCheckout = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings;
    var ref = (0,react.useState)(null), stripe = ref[0], setStripe = ref[1];
    var onSubmit = useEmbeddedCheckout().onSubmit;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,dist.useTheme)(), updateLayoutMode = ref1.updateLayoutMode, resetLayoutMode = ref1.resetLayoutMode;
    var ref2 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), item = ref2.item, mode = ref2.mode;
    var ref3 = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        fields
    ]), liveModePublishableKey = ref3.liveModePublishableKey, testModePublishableKey = ref3.testModePublishableKey, stripeMode = ref3.mode, hostedPagesEnvironmentVariable = ref3.hostedPagesEnvironmentVariable;
    var fetchClientSecret = (0,react.useCallback)(function() {
        return fetch("/api/stripe/session", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                hostedPagesSessionId: router.query.sessionId,
                stripeMode: stripeMode,
                mode: mode,
                item: item,
                hostedPagesEnvironmentVariable: hostedPagesEnvironmentVariable
            })
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            return data.clientSecret;
        });
    }, []);
    var options = {
        fetchClientSecret: fetchClientSecret
    };
    var handleSubmit = (0,react.useCallback)(function() {
        onSubmit({
            activityId: activity_id,
            success: true
        });
    }, [
        activity_id,
        onSubmit
    ]);
    (0,react.useEffect)(function() {
        updateLayoutMode("flexible");
        (0,stripe_js_lib/* loadStripe */.J)(stripeMode === "Test" ? testModePublishableKey : liveModePublishableKey).then(function(stripeInstance) {
            setStripe(stripeInstance);
        });
        /**
     * If this is set in the URL,
     * then we know it's a callback from Stripe
     */ var stripeSessionId = router.query.stripeSessionId;
        if (stripeSessionId) {
            fetch("/api/stripe/session?stripeSessionId=".concat(stripeSessionId, "&hostedPagesEnvironmentVariable=").concat(hostedPagesEnvironmentVariable, "&stripeMode=").concat(stripeMode), {
                method: "GET"
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                /** Complete the activity when payment was successful */ if (data.status === "complete") {
                    handleSubmit();
                }
            });
        }
        return function() {
            resetLayoutMode();
        };
    }, [
        router.query,
        updateLayoutMode,
        resetLayoutMode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: stripe && options && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((EmbeddedCheckout_module_default()).container),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.EmbeddedCheckoutProvider, {
                    stripe: stripe,
                    options: options,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.EmbeddedCheckout, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
            ]
        })
    });
};
EmbeddedCheckout.displayName = "EnterMedication";

;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/actions/EmbeddedCheckout/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/actions/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/StripeExtension.tsx






var StripeExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case StripeExtension_types_ActionKey.EMBEDDED_CHECKOUT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedCheckout, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
StripeExtension.displayName = "ExperimentalExtension";

;// CONCATENATED MODULE: ./src/components/Extension/StripeExtension/index.tsx


// EXTERNAL MODULE: ./src/components/Extension/IdentityVerification/actions/DobCheck/DobCheck.module.css
var DobCheck_module = __webpack_require__(3800);
var DobCheck_module_default = /*#__PURE__*/__webpack_require__.n(DobCheck_module);
;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/types.ts

var IdentityVerification_types_ActionKey;
(function(ActionKey) {
    ActionKey["DOB_CHECK"] = "dobCheck";
})(IdentityVerification_types_ActionKey || (IdentityVerification_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/actions/DobCheck/hooks/useDobCheck.tsx





var useDobCheck = function(param) {
    var pathway_id = param.pathway_id, activity_id = param.activity_id;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = useCompleteExtensionActivity(), isSubmitting = ref1.isSubmitting, _onSubmit = ref1.onSubmit;
    var handleActivityCompletion = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId;
                        return _ctx.abrupt("return", _onSubmit(activityId, [
                            {
                                key: "success",
                                value: String(true)
                            }
                        ]));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(dob) {
            var response, jsonRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(0,lodash.isEmpty)(dob)) {
                            _ctx.next = 3;
                            break;
                        }
                        // Prettify this later
                        alert("Please enter a date of birth");
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        setLoading(true);
                        _ctx.next = 7;
                        return fetch("/api/identity/verify", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                dob: dob,
                                pathway_id: pathway_id,
                                activity_id: activity_id
                            })
                        });
                    case 7:
                        response = _ctx.sent;
                        setLoading(false);
                        if (response.ok) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Failed to check dob");
                    case 11:
                        _ctx.next = 13;
                        return response.json();
                    case 13:
                        jsonRes = _ctx.sent;
                        if (jsonRes === null || jsonRes === void 0 ? void 0 : jsonRes.success) {
                            _ctx.next = 17;
                            break;
                        }
                        // Prettify this later
                        alert("No match");
                        return _ctx.abrupt("return");
                    case 17:
                        handleActivityCompletion({
                            activityId: activity_id
                        });
                        _ctx.next = 24;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](3);
                        console.error("Error checking dob:", _ctx.t0);
                        throw _ctx.t0;
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    20
                ]
            ]);
        }));
        return function(dob) {
            return _ref.apply(this, arguments);
        };
    }(), [
        pathway_id,
        activity_id,
        handleActivityCompletion
    ]);
    return {
        loading: loading,
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/actions/DobCheck/DobCheck.tsx








var DobCheck = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(""), dobValue = ref[0], setDobValue = ref[1];
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, pathway_id = activityDetails.pathway_id;
    var ref1 = useDobCheck({
        pathway_id: pathway_id,
        activity_id: activity_id
    }), loading = ref1.loading, onSubmit = ref1.onSubmit;
    var label = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "ahp_main_content_with_scroll_hint",
                className: (ActivityLayout_module_default()).main_content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((DobCheck_module_default()).container, " ").concat((DobCheck_module_default()).groupMedsListContainer),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DobCheck_module_default()).inputWrapper,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CircularSpinner, {
                            size: "sm"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InputField, {
                            id: "name",
                            label: label !== null && label !== void 0 ? label : t("activities.identity_verification.default_label"),
                            type: "date",
                            value: dobValue,
                            onChange: function(e) {
                                return setDobValue(e.target.value);
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HostedPageFooter, {
                showScrollHint: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((ActivityLayout_module_default()).button_wrapper, " ").concat((DobCheck_module_default()).container),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                        variant: "primary",
                        onClick: function() {
                            return onSubmit(dobValue);
                        },
                        disabled: loading,
                        children: t("activities.identity_verification.cta")
                    })
                })
            })
        ]
    });
};
DobCheck.displayName = "DobCheck";

;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/actions/DobCheck/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/actions/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/IdentityVerification.tsx






var IdentityVerification = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case IdentityVerification_types_ActionKey.DOB_CHECK:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DobCheck, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
IdentityVerification.displayName = "IdentityVerification";

;// CONCATENATED MODULE: ./src/components/Extension/IdentityVerification/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/Extension.tsx

















var Extension = function(param) {
    var activity = param.activity;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = useExtensionActivity(activity.object.id), loading = ref1.loading, extensionActivityDetails = ref1.extensionActivityDetails, error = ref1.error, refetch = ref1.refetch;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    if (error || !extensionActivityDetails) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.checklist.loading_error", {
                error: error
            }),
            onRetry: refetch
        });
    }
    /**
   * FOR PRIVATE EXTENSIONS
   */ var getDefaultReturnValue = function() {
        switch(extensionActivityDetails.plugin_action_key){
            case AnonymousActionKeys.COLLECT_MEDICATION:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterMedication, {
                    activityDetails: extensionActivityDetails
                });
            case AnonymousActionKeys.PATIENT_RECOMMENDATION:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PatientRecommendation, {
                    activityDetails: extensionActivityDetails
                });
            case AnonymousActionKeys.REDIRECT:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Redirect, {
                    activityDetails: extensionActivityDetails
                });
            case AnonymousActionKeys.INTAKE_SCHEDULING:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntakeScheduling, {
                    activityDetails: extensionActivityDetails
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                    title: t("activities.activity_not_supported")
                });
        }
    };
    switch(activity === null || activity === void 0 ? void 0 : (ref = activity.indirect_object) === null || ref === void 0 ? void 0 : ref.id){
        case ExtensionKey.CAL_DOT_COM:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalDotComExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.DROPBOXSIGN:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropboxSignExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.CLOUDINARY:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.FORMSORT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormsortExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.DOCU_SIGN:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocuSignExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.COLLECT_DATA:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectDataExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.STRIPE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.IDENTITY_VERIFICATION:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IdentityVerification, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.EXPERIMENTAL:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperimentalExtension, {
                activityDetails: extensionActivityDetails
            });
        default:
            return getDefaultReturnValue();
    }
};
Extension.displayName = "Extension";

;// CONCATENATED MODULE: ./src/components/Extension/index.ts


;// CONCATENATED MODULE: ./src/components/Activities/ActivityFactory.tsx











var ActivityFactory = function(param) {
    var activity = param.activity;
    var t = (0,esm/* useTranslation */.$G)().t;
    var infoLog = (0,useLogging/* useLogging */.K)().infoLog;
    (0,react.useEffect)(function() {
        infoLog({
            msg: "Loading new activity",
            activity: activity
        }, types/* LogEvent.ACTIVITY_LOADING */.g.ACTIVITY_LOADING);
    }, []);
    switch(activity === null || activity === void 0 ? void 0 : activity.object.type){
        case types_orchestration/* ActivityObjectType.Form */.tK.Form:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                activity: activity
            }, activity.id);
        case types_orchestration/* ActivityObjectType.Message */.tK.Message:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                activity: activity
            }, activity.id);
        case types_orchestration/* ActivityObjectType.Checklist */.tK.Checklist:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checklist, {
                activity: activity
            }, activity.id);
        case types_orchestration/* ActivityObjectType.PluginAction */.tK.PluginAction:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Extension, {
                activity: activity
            }, activity.id);
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};

;// CONCATENATED MODULE: ./src/components/Activities/Activities.tsx





// session will already expire after 15 seconds
var RELOAD_DELAY = 20000;
var Activities = function() {
    var ref = useCurrentActivity(), currentActivity = ref.currentActivity, waitingForNewActivities = ref.waitingForNewActivities;
    (0,react.useEffect)(function() {
        var reloadTimer;
        if (waitingForNewActivities) {
            reloadTimer = setTimeout(function() {
                window.location.reload();
            }, RELOAD_DELAY);
        }
        // clear interval on component unmount
        return function() {
            if (reloadTimer) {
                clearTimeout(reloadTimer);
            }
        };
    }, [
        waitingForNewActivities
    ]);
    if (waitingForNewActivities) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFactory, {
        activity: currentActivity
    });
};

;// CONCATENATED MODULE: ./src/components/Activities/ActivitiesContainer.tsx




var ActivitiesContainer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Activities, {})
    });
};

;// CONCATENATED MODULE: ./src/components/Activities/index.ts



;// CONCATENATED MODULE: ./src/components/CloseHostedSessionModal/CloseHostedSessionModal.tsx



var CloseHostedSessionModal = function(param) {
    var isModalOpen = param.isModalOpen, onCloseModal = param.onCloseModal, onCloseHostedSession = param.onCloseHostedSession;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Modal, {
        isOpen: isModalOpen,
        title: t("session.close_modal.title"),
        description: t("session.close_modal.description"),
        onCloseModal: onCloseModal,
        icon: "warning",
        buttons: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                variant: "primary",
                onClick: onCloseModal,
                children: t("session.close_modal.cancel_button_label")
            }, "cancel-button"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                variant: "tertiary",
                onClick: onCloseHostedSession,
                children: t("session.close_modal.confirm_button_label")
            }, "confirm-button"), 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CloseHostedSessionModal/index.tsx


;// CONCATENATED MODULE: ./src/components/index.ts








/***/ }),

/***/ 3248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AWELL_BRAND_COLOR; }
/* harmony export */ });
var AWELL_BRAND_COLOR = "#004ac2";


/***/ }),

/***/ 4287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ useHostedSession; }
});

// EXTERNAL MODULE: ./src/types/generated/types-orchestration.tsx
var types_orchestration = __webpack_require__(5852);
;// CONCATENATED MODULE: ./src/hooks/useHostedSession/types.ts


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(6252);
// EXTERNAL MODULE: ./src/services/graphql/index.ts + 2 modules
var graphql = __webpack_require__(4342);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./src/hooks/useHostedSession/branding/stringToJson.ts

var stringToJSONSchema = lib.z.string().optional().transform(function(str) {
    try {
        return JSON.parse(str !== null && str !== void 0 ? str : "");
    } catch (e) {
        return {};
    }
});

;// CONCATENATED MODULE: ./src/hooks/useHostedSession/branding/customTheme.ts


var DEFAULTS = {
    layout: {
        showCloseButton: true,
        showLogo: true
    },
    form: {
        showProgressBar: true,
        showAsterisksForRequiredQuestions: true
    }
};
var CustomLayoutBranding = lib.z.object({
    showCloseButton: lib.z.boolean().default(DEFAULTS.layout.showCloseButton),
    showLogo: lib.z.boolean().optional().default(DEFAULTS.layout.showLogo)
}).default({});
var CustomFormBranding = lib.z.object({
    showProgressBar: lib.z.boolean().default(DEFAULTS.form.showProgressBar),
    showAsterisksForRequiredQuestions: lib.z.boolean().default(DEFAULTS.form.showAsterisksForRequiredQuestions)
}).default({});
/**
 * Set default to empty string
 */ var CustomLocales = lib.z.object({
    form: lib.z.object({
        next_question_label: lib.z.string().default(""),
        previous_question_label: lib.z.string().default(""),
        cta_submit: lib.z.string().default("")
    }).default({}),
    message: lib.z.object({
        cta_mark_as_read: lib.z.string().default("")
    }).default({}),
    checklist: lib.z.object({
        cta_submit: lib.z.string().default("")
    }).default({})
}).default({});
var CustomThemeFields = lib.z.object({
    layout: CustomLayoutBranding,
    form: CustomFormBranding,
    locales: CustomLocales
}).default({});
var CustomThemeSchema = stringToJSONSchema.pipe(CustomThemeFields);
var getTheme = function(customThemeJsonStr) {
    var customTheme = customThemeJsonStr !== null && customThemeJsonStr !== void 0 ? customThemeJsonStr : "";
    return CustomThemeSchema.parse(customTheme);
};

;// CONCATENATED MODULE: ./src/hooks/useHostedSession/branding/index.ts


;// CONCATENATED MODULE: ./src/hooks/useHostedSession/useHostedSession.ts
/* eslint-disable react-hooks/exhaustive-deps */ 








var POLLING_DELAY_MS = 2000;
var useHostedSession = function() {
    var ref, ref1, ref2, ref3, ref4;
    var defaultTheme = getTheme();
    var ref5 = (0,react.useState)(false), isSessionCompleted = ref5[0], setIsSessionCompleted = ref5[1];
    var pollInterval = isSessionCompleted ? undefined : POLLING_DELAY_MS;
    var ref6 = (0,types_orchestration/* useGetHostedSessionQuery */.ZB)({
        pollInterval: pollInterval,
        onError: function(error) {
            esm_exports/* captureException */.Tb(error, {
                contexts: {
                    graphql: {
                        query: "GetHostedSession"
                    }
                }
            });
        }
    }), data = ref6.data, loading = ref6.loading, error = ref6.error, refetch = ref6.refetch, stopPolling = ref6.stopPolling;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var router = (0,next_router.useRouter)();
    var onHostedSessionCompleted = (0,types_orchestration/* useOnHostedSessionCompletedSubscription */.GW)();
    var onHostedSessionExpired = (0,types_orchestration/* useOnHostedSessionExpiredSubscription */.RI)();
    var updateHostedSessionQuery = function(param) {
        var updatedHostedSession = param.updatedHostedSession;
        var updatedQuery = (0,graphql/* updateQuery */.rh)(data, [
            "hostedSession",
            "session"
        ], updatedHostedSession);
        client.writeQuery({
            query: types_orchestration/* GetHostedSessionDocument */.FD,
            data: updatedQuery
        });
        if (updatedHostedSession.status === types_orchestration/* HostedSessionStatus.Completed */.Q5.Completed || updatedHostedSession.status === types_orchestration/* HostedSessionStatus.Expired */.Q5.Expired) {
            setIsSessionCompleted(true);
        }
    };
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(router)) {
            esm_exports/* setTags */.mG({
                session: router.query.sessionId,
                api_endpoint: "https://api.development.awellhealth.com/orchestration/graphql"
            });
        }
    });
    (0,react.useEffect)(function() {
        if (isSessionCompleted) {
            stopPolling();
        }
    }, [
        isSessionCompleted
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!(0,lodash.isNil)(data === null || data === void 0 ? void 0 : (ref = data.hostedSession) === null || ref === void 0 ? void 0 : ref.session)) {
            var hostedSession = data === null || data === void 0 ? void 0 : data.hostedSession.session;
            esm_exports/* setTags */.mG({
                pathway: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.pathway_id,
                stakeholder: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.id
            });
            esm_exports/* setContext */.v("session", {
                id: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.id,
                pathway_id: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.pathway_id,
                success_url: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.success_url,
                cancel_url: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.cancel_url
            });
            esm_exports/* setContext */.v("stakeholder", {
                id: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.id,
                name: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.name,
                type: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.type
            });
            esm_exports/* setExtras */.rJ({
                hostedSession: hostedSession,
                branding: data === null || data === void 0 ? void 0 : data.hostedSession.branding
            });
            if (hostedSession && (hostedSession.status === types_orchestration/* HostedSessionStatus.Completed */.Q5.Completed || hostedSession.status === types_orchestration/* HostedSessionStatus.Expired */.Q5.Expired)) {
                setIsSessionCompleted(true);
            }
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(onHostedSessionCompleted.data)) {
            var sessionCompleted = onHostedSessionCompleted.data.sessionCompleted;
            updateHostedSessionQuery({
                updatedHostedSession: sessionCompleted
            });
        }
    }, [
        client,
        onHostedSessionCompleted.data
    ]);
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(onHostedSessionExpired.data)) {
            var sessionExpired = onHostedSessionExpired.data.sessionExpired;
            updateHostedSessionQuery({
                updatedHostedSession: sessionExpired
            });
        }
    }, [
        client,
        onHostedSessionExpired.data
    ]);
    if (loading) {
        return {
            loading: true,
            theme: defaultTheme
        };
    }
    if (error) {
        var ref7;
        var unauthorizedError = (ref7 = error.graphQLErrors) === null || ref7 === void 0 ? void 0 : ref7.find(function(err) {
            var ref;
            return ((ref = err.extensions) === null || ref === void 0 ? void 0 : ref.code) === "UNAUTHORIZED";
        });
        var message = unauthorizedError ? "UNAUTHORIZED" : error.message;
        return {
            loading: false,
            error: message,
            refetch: refetch,
            theme: defaultTheme
        };
    }
    return {
        loading: false,
        session: data === null || data === void 0 ? void 0 : (ref = data.hostedSession) === null || ref === void 0 ? void 0 : ref.session,
        metadata: data === null || data === void 0 ? void 0 : (ref1 = data.hostedSession) === null || ref1 === void 0 ? void 0 : ref1.metadata,
        branding: data === null || data === void 0 ? void 0 : (ref2 = data.hostedSession) === null || ref2 === void 0 ? void 0 : ref2.branding,
        theme: getTheme(data === null || data === void 0 ? void 0 : (ref3 = data.hostedSession) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.branding) === null || ref4 === void 0 ? void 0 : ref4.custom_theme),
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useHostedSession/index.ts



/***/ }),

/***/ 4128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ useLogging; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(4727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(4251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(2875);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/services/authentication/index.ts + 3 modules
var authentication = __webpack_require__(8803);
// EXTERNAL MODULE: ./src/hooks/useHostedSession/index.ts + 5 modules
var useHostedSession = __webpack_require__(4287);
;// CONCATENATED MODULE: ./src/hooks/useLogging/useLogging.ts






var useLogging = function() {
    var authContext = (0,authentication/* useAuthentication */.J)();
    var ref = (0,useHostedSession/* useHostedSession */.H)(), session = ref.session, metadata = ref.metadata;
    var log = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params, severity, event, error) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("/api/log", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                    authContext: authContext,
                                    session: session,
                                    metadata: metadata,
                                    event: event
                                }),
                                client_timestamp: new Date().toISOString(),
                                severity: severity,
                                error: error
                            })
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function log(params, severity, event, error) {
            return _ref.apply(this, arguments);
        };
    }();
    var infoLog = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params, event) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return log(params, "INFO", event);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function infoLog(params, event) {
            return _ref.apply(this, arguments);
        };
    }();
    var warningLog = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params, event) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return log(params, "WARNING", event);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function warningLog(params, event) {
            return _ref.apply(this, arguments);
        };
    }();
    var errorLog = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params, error, event) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return log(params, "ERROR", event, error);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function errorLog(params, error, event) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        log: log,
        infoLog: infoLog,
        warningLog: warningLog,
        errorLog: errorLog
    };
};

;// CONCATENATED MODULE: ./src/hooks/useLogging/index.ts



/***/ }),

/***/ 5064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ LogEvent; }
/* harmony export */ });
var LogEvent;
(function(LogEvent) {
    LogEvent["FORM_SUBMITTING"] = "FORM_SUBMITTING";
    LogEvent["FORM_SUBMITTED"] = "FORM_SUBMITTED";
    LogEvent["FORM_SUBMISSION_FAILED"] = "FORM_SUBMISSION_FAILED";
    LogEvent["FORM_WAITING_FOR_SUBMISSION"] = "FORM_WAITING_FOR_SUBMISSION";
    LogEvent["FORM_WAITING_FOR_FETCH"] = "FORM_WAITING_FOR_FETCH";
    LogEvent["FORM_FETCH_FAILED"] = "FORM_FETCH_FAILED";
    LogEvent["SESSION_ONGOING"] = "SESSION_ONGOING";
    LogEvent["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    LogEvent["SESSION_COMPLETED"] = "SESSION_COMPLETED";
    LogEvent["MESSAGE_MARKING_AS_READ"] = "MESSAGE_MARKING_AS_READ";
    LogEvent["MESSAGE_MARKED_AS_READ"] = "MESSAGE_MARKED_AS_READ";
    LogEvent["MESSAGE_MARKING_AS_READ_FAILED"] = "MESSAGE_MARKING_AS_READ_FAILED";
    LogEvent["CHECKLIST_SUBMITTING"] = "CHECKLIST_SUBMITTING";
    LogEvent["CHECKLIST_SUBMITTED"] = "CHECKLIST_SUBMITTED";
    LogEvent["CHECKLIST_SUBMITTING_FAILED"] = "CHECKLIST_SUBMITTING_FAILED";
    LogEvent["ACTIVITIES_FETCH"] = "ACTIVITIES_FETCH";
    LogEvent["ACTIVITIES_FETCH_FAILED"] = "ACTIVITIES_FETCH_FAILED";
    LogEvent["ACTIVITY_LOADING"] = "ACTIVITY_LOADING";
    LogEvent["ACTIVITIES_LIST_CHANGED"] = "ACTIVITIES_LIST_CHANGED";
    LogEvent["ACTIVITY_IS_ACTIVE"] = "ACTIVITY_IS_ACTIVE";
    LogEvent["ACTIVITIES_START_POLLING"] = "ACTIVITIES_START_POLLING";
    LogEvent["ACTIVITIES_STOP_POLLING"] = "ACTIVITIES_STOP_POLLING";
    LogEvent["GRAPHQL_WS_CONNECTED"] = "GRAPHQL_WS_CONNECTED";
    LogEvent["GRAPHQL_WS_ERROR"] = "GRAPHQL_WS_ERROR";
    LogEvent["GRAPHQL_WS_DISCONNECTED"] = "GRAPHQL_WS_DISCONNECTED";
})(LogEvent || (LogEvent = {}));


/***/ }),

/***/ 2107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useSessionStorage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8732);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useSessionStorage = function(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        if (false) {}
        try {
            var item = window.sessionStorage.getItem(key);
            return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.defaultTo)(item, initialValue);
        } catch (error) {
            return initialValue;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to sessionStorage.
    var setValue = function(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value, Function) ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            if (true) {
                window.sessionStorage.setItem(key, valueToStore);
            }
        } catch (error) {
            console.warn("Error setting sessionStorage value: ", error);
        }
    };
    var removeItem = function() {
        if (false) {}
        window.sessionStorage.removeItem(key);
    };
    return {
        storedValue: storedValue,
        setValue: setValue,
        removeItem: removeItem
    };
};


/***/ }),

/***/ 2041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ addSentryBreadcrumb; },
/* harmony export */   "j": function() { return /* binding */ BreadcrumbCategory; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7573);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4487);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);



var BreadcrumbCategory;
(function(BreadcrumbCategory) {
    BreadcrumbCategory["EVALUATE_FORM_RULES"] = "EVALUATE_FORM_RULES";
    BreadcrumbCategory["SUBMIT_FORM"] = "SUBMIT_FORM";
    BreadcrumbCategory["SESSION_COMPLETE"] = "SESSION_COMPLETE";
    BreadcrumbCategory["SESSION_EXPIRE"] = "SESSION_EXPIRE";
    BreadcrumbCategory["SESSION_CANCEL"] = "SESSION_CANCEL";
    BreadcrumbCategory["READ_MESSAGE"] = "READ_MESSAGE";
    BreadcrumbCategory["SUBMIT_CHECKLIST"] = "SUBMIT_CHECKLIST";
    BreadcrumbCategory["GENERIC"] = "GENERIC";
    BreadcrumbCategory["NAVIGATION"] = "NAVIGATION";
    BreadcrumbCategory["SLOW_REDIRECT"] = "SLOW_REDIRECT";
    BreadcrumbCategory["HOSTED_PAGES_LINK_ERROR"] = "HOSTED_PAGES_LINK_ERROR";
    BreadcrumbCategory["HOSTED_ACTIVITY_ERROR"] = "HOSTED_ACTIVITY_ERROR";
})(BreadcrumbCategory || (BreadcrumbCategory = {}));
var _obj;
var SentryBreadcrumbMessageDictionary = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.EVALUATE_FORM_RULES, "Evaluating form rules"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SUBMIT_FORM, "Submitting form"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SESSION_COMPLETE, "Session completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SESSION_CANCEL, "Session cancelled"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SESSION_EXPIRE, "Session expired"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.READ_MESSAGE, "Reading message"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SUBMIT_CHECKLIST, "Submitting checklist"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.GENERIC, "Generic event"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.NAVIGATION, "Navigation"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SLOW_REDIRECT, "Slow redirect at session end"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.HOSTED_PAGES_LINK_ERROR, "Error with hosted pages link"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.HOSTED_ACTIVITY_ERROR, "Error with hosted activity link"), _obj);
var addSentryBreadcrumb = function(param) {
    var category = param.category, data = param.data;
    (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .addBreadcrumb */ .n_)({
        message: (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(SentryBreadcrumbMessageDictionary, category, // default:
        SentryBreadcrumbMessageDictionary[BreadcrumbCategory.GENERIC]),
        category: category,
        data: {
            context: JSON.stringify(data)
        }
    });
};


/***/ }),

/***/ 8644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ addSentryBreadcrumb/* addSentryBreadcrumb */.b; },
  "g": function() { return /* reexport */ masker; }
});

// EXTERNAL MODULE: ./src/services/ErrorReporter/addSentryBreadcrumb.ts
var addSentryBreadcrumb = __webpack_require__(2041);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(969);
;// CONCATENATED MODULE: ./src/services/ErrorReporter/masker.ts
/**
 * Masker function to mask sensitive data from form related breadcrumbs. This assumes
 * that the object(s) have a field called value that needs to be masked.
 * @param value this is the value to be masked, can be an object or an array of
 * objects with a value field
 * @returns the masked object or array of objects
 */ 
var masker = function(value) {
    if (Array.isArray(value)) {
        return value.map(masker);
    }
    if (typeof value === "object" && value !== null && value !== undefined) {
        return Object.fromEntries(Object.entries(value).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], _$value = _param[1];
            if (key !== "value") {
                return [
                    key,
                    _$value
                ];
            }
            return [
                key,
                typeof _$value === "string" || typeof _$value === "number" ? "*".repeat(_$value.toString().length) : masker(_$value), 
            ];
        }));
    }
    return value;
};

;// CONCATENATED MODULE: ./src/services/ErrorReporter/index.ts




/***/ }),

/***/ 8803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ AuthenticationProvider; },
  "J": function() { return /* reexport */ useAuthentication; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/services/authentication/AuthenticationContext.ts

var initialContext = {
    isAuthenticated: false
};
var AuthenticationContext = (0,react.createContext)(initialContext);

// EXTERNAL MODULE: ./src/hooks/useSessionStorage/index.ts
var useSessionStorage = __webpack_require__(2107);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/components/index.ts + 139 modules
var components = __webpack_require__(7624);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./src/services/ErrorReporter/addSentryBreadcrumb.ts
var addSentryBreadcrumb = __webpack_require__(2041);
;// CONCATENATED MODULE: ./src/services/authentication/AuthenticationProvider.tsx










var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
/*
 * Authentication is done in the following steps:
 * 1. On first load, we remove the accessToken from the sessionStorage. Why? Because sessions are short-termed and are expected to last for short timespans. So we remove the last token for any conflicts between the consecutive sessions.
 * 2. Then we create a new token using the NextJS API and save it as 'accessToken' in sessionStorage. While we create a new accessToken, no other operation is allowed. So loader is shown. 'tokenLoading' state locks the app from further execution.
 * 3. Once accessToken is generated, only then the children components of the app are rendered.
 */ var AuthenticationProvider = function(param) {
    var children = param.children;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,useSessionStorage/* useSessionStorage */.X)("accessToken", ""), accessToken = ref.storedValue, setAccessToken = ref.setValue, removeAccessToken = ref.removeItem;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(true), tokenLoading = ref1[0], setTokenLoading = ref1[1];
    var ref2 = (0,dist/* default */.ZP)(router.query.sessionId ? "/api/session/".concat(router.query.sessionId) : null, fetcher), data = ref2.data, error = ref2.error;
    // @REVIEW - why do we remove the token rather than overwriting/replacing it
    (0,react.useEffect)(function() {
        // remove access token on first load
        removeAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.token) {
            setAccessToken(data === null || data === void 0 ? void 0 : data.token);
            setTokenLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : data.token
    ]);
    var authenticationContext = {
        isAuthenticated: accessToken !== "",
        accessToken: accessToken,
        error: error
    };
    if (router.isReady && !router.query.sessionId) {
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.NAVIGATION */.j.NAVIGATION,
            message: "Invalid URL",
            data: {
                url: router.asPath,
                sessionId: router.query.sessionId
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorPage */.mf, {
            title: t("session.invalid_url")
        });
    }
    // Wait while token is being generated
    if (!router.isReady || tokenLoading) {
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.NAVIGATION */.j.NAVIGATION,
            message: "Preparing router and/or token",
            data: {
                url: router.asPath,
                sessionId: router.query.sessionId
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {
            showLogoBox: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticationContext.Provider, {
        value: authenticationContext,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/services/authentication/useAuthentication.ts


var useAuthentication = function() {
    return (0,react.useContext)(AuthenticationContext);
};

;// CONCATENATED MODULE: ./src/services/authentication/index.ts




/***/ }),

/***/ 4342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eI": function() { return /* reexport */ createClient; },
  "rh": function() { return /* reexport */ updateQuery; }
});

// UNUSED EXPORTS: createApolloCacheUpdate

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9779);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js + 14 modules
var createHttpLink = __webpack_require__(5465);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(6909);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/split.js
var split = __webpack_require__(5367);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 13 modules
var ApolloClient = __webpack_require__(1954);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 8 modules
var inMemoryCache = __webpack_require__(6118);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/subscriptions/index.js
var subscriptions = __webpack_require__(5210);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/graphql-ws/lib/client.mjs + 2 modules
var client = __webpack_require__(2037);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
;// CONCATENATED MODULE: ./src/services/graphql/apollo-client.ts







var createClient = function(param) {
    var httpUri = param.httpUri, wsUri = param.wsUri, _onNetworkError = param.onNetworkError, onNetworkError = _onNetworkError === void 0 ? function() {
        return undefined;
    } : _onNetworkError, _extraLinks = param.extraLinks, extraLinks = _extraLinks === void 0 ? [] : _extraLinks, cacheConfig = param.cacheConfig;
    var httpLink = (0,createHttpLink/* createHttpLink */.L)({
        uri: httpUri
    });
    var errorHandlingLink = (0,error/* onError */.q)(function(response) {
        if (response.networkError) {
            onNetworkError(response);
        }
    });
    var authenticationLink = new ApolloLink/* ApolloLink */.i(function(operation, forward) {
        // why do we need to use sessionStorage here? Can we not pass the token in to this
        // function from the GraphqlWrapper component?
        var accessToken = sessionStorage.getItem("accessToken");
        operation.setContext({
            headers: {
                authorization: accessToken ? "Bearer ".concat(accessToken) : ""
            }
        });
        return forward(operation);
    });
    var createWsLink = function() {
        if ((0,lodash.isNil)(window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("accessToken"))) {
            return null;
        }
        if ((window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("TEST_DISABLE_SUBSCRIPTIONS")) === "true") {
            console.info("Disabling GraphQL subscriptions for testing purposes");
            return null;
        }
        return new subscriptions/* GraphQLWsLink */.g((0,client/* createClient */.eI)({
            url: wsUri,
            connectionParams: {
                authToken: window.sessionStorage.getItem("accessToken")
            }
        }));
    };
    var wsLink = createWsLink();
    var isSubscription = function(param) {
        var query = param.query;
        var definition = (0,getFromAST/* getMainDefinition */.p$)(query);
        return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    };
    var defaultLink = ApolloLink/* ApolloLink.from */.i.from([
        authenticationLink, 
    ].concat((0,_to_consumable_array/* default */.Z)(extraLinks), [
        errorHandlingLink,
        httpLink, 
    ]));
    var link = wsLink ? (0,split/* split */.V)(isSubscription, wsLink, defaultLink) : defaultLink;
    return new ApolloClient/* ApolloClient */.f({
        ssrMode: "object" === "undefined",
        connectToDevTools: "production" !== "production",
        cache: new inMemoryCache/* InMemoryCache */.h(cacheConfig),
        link: link,
        credentials: "include"
    });
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7573);
;// CONCATENATED MODULE: ./src/services/graphql/createApolloCacheUpdate.ts


var createApolloCacheUpdate = function(param) {
    var query = param.query, variables = param.variables, updateFunction = param.updateFunction;
    var update = function(cache, result) {
        var cachedQuery = cache.readQuery({
            query: query,
            variables: variables
        });
        var updatedCachedQuery = updateFunction({
            result: result,
            query: cachedQuery
        });
        cache.writeQuery({
            query: query,
            variables: variables,
            data: updatedCachedQuery
        });
    };
    return update;
};
/**
 * Convenience function to update a query without having to manually
 * copy the query object and put the new value in the right place.
 * Why not use lodash or ramda directly ? Typing lenses in ramda
 * is a pain in the arse, and lodash doesn't have a typed function
 * that can updated a nested property.
 * This function has the benefit of being typed: the path is automatically
 * infered and validated by typescript depending on the query type.
 * The value type isn't inferred though so it still needs to be explicitly
 * defined by the calling code.
 */ var updateQuery = function(query, path, value) {
    var propertyPath = path;
    // Build an object that can be used with assign to update the query.
    // Example:
    // ```
    // const path = ['some', 'nested', 'property']
    // const value = ['a', 'list', 'of', 'values']
    // const updateObj = {
    //   some: {
    //     nested: {
    //       property: ['a', 'list', 'of', 'values']
    //     }
    //   }
    // }
    var updateObj = propertyPath.reverse().reduce(function(agg, currentProperty) {
        return (0,_define_property/* default */.Z)({}, currentProperty, agg);
    }, value);
    // By default lodash merges array, which makes it impossible
    // to remove array items. This customiser overrides that behaviour
    // to use only the source value when it is an array.
    // See https://lodash.com/docs/4.17.15#mergeWith
    var replaceArray = function(objValue, srcValue) {
        if (Array.isArray(srcValue)) {
            return srcValue;
        }
        return undefined;
    };
    return (0,lodash.mergeWith)({}, query, updateObj, replaceArray);
};

;// CONCATENATED MODULE: ./src/services/graphql/index.ts




/***/ }),

/***/ 5852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ useGetChecklistQuery; },
/* harmony export */   "Ed": function() { return /* binding */ useOnSessionActivityCreatedSubscription; },
/* harmony export */   "FD": function() { return /* binding */ GetHostedSessionDocument; },
/* harmony export */   "GW": function() { return /* binding */ useOnHostedSessionCompletedSubscription; },
/* harmony export */   "H3": function() { return /* binding */ useMarkMessageAsReadMutation; },
/* harmony export */   "OJ": function() { return /* binding */ FormDisplayMode; },
/* harmony export */   "Pp": function() { return /* binding */ useCompleteExtensionActivityMutation; },
/* harmony export */   "Q5": function() { return /* binding */ HostedSessionStatus; },
/* harmony export */   "RI": function() { return /* binding */ useOnHostedSessionExpiredSubscription; },
/* harmony export */   "Wy": function() { return /* binding */ GetHostedSessionActivitiesDocument; },
/* harmony export */   "YD": function() { return /* binding */ useGetMessageQuery; },
/* harmony export */   "ZB": function() { return /* binding */ useGetHostedSessionQuery; },
/* harmony export */   "a$": function() { return /* binding */ useGetHostedSessionActivitiesQuery; },
/* harmony export */   "bK": function() { return /* binding */ useOnSessionActivityExpiredSubscription; },
/* harmony export */   "fU": function() { return /* binding */ ActivityStatus; },
/* harmony export */   "hp": function() { return /* binding */ useSubmitFormResponseMutation; },
/* harmony export */   "im": function() { return /* binding */ useGetExtensionActivityDetailsQuery; },
/* harmony export */   "lj": function() { return /* binding */ useEvaluateFormRulesMutation; },
/* harmony export */   "oA": function() { return /* binding */ useSubmitChecklistMutation; },
/* harmony export */   "q6": function() { return /* binding */ useGetFormQuery; },
/* harmony export */   "tF": function() { return /* binding */ useOnSessionActivityCompletedSubscription; },
/* harmony export */   "tK": function() { return /* binding */ ActivityObjectType; }
/* harmony export */ });
/* unused harmony exports ActionType, ActivityAction, ActivityResolution, ActivitySubjectType, AllowedDatesOptions, ApiCallRequestMethod, ApiCallStatus, BooleanOperator, ConditionOperandType, ConditionOperator, DataPointSourceType, DataPointValueType, ElementStatus, ElementType, ExtensionActionFieldType, HostedSessionStakeholderType, MessageAttachmentType, MessageFormat, PathwayStatus, QuestionType, Sex, StakeholderClinicalAppRole, SwimlaneItemCategory, SwimlaneItemType, UserQuestionType, QuestionFragmentDoc, FormFragmentDoc, HostedSessionFragmentDoc, ActivityFragmentDoc, GetChecklistDocument, useGetChecklistLazyQuery, CompleteExtensionActivityDocument, EvaluateFormRulesDocument, GetExtensionActivityDetailsDocument, useGetExtensionActivityDetailsLazyQuery, GetFormDocument, useGetFormLazyQuery, GetFormResponseDocument, useGetFormResponseQuery, useGetFormResponseLazyQuery, OnHostedSessionCompletedDocument, OnHostedSessionExpiredDocument, useGetHostedSessionLazyQuery, GetMessageDocument, useGetMessageLazyQuery, MarkMessageAsReadDocument, useGetHostedSessionActivitiesLazyQuery, OnSessionActivityCompletedDocument, OnSessionActivityCreatedDocument, OnSessionActivityExpiredDocument, OnSessionActivityUpdatedDocument, useOnSessionActivityUpdatedSubscription, SubmitChecklistDocument, SubmitFormResponseDocument */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4251);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2692);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7878);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7887);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(319);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5436);
/* eslint-disable */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment Question on Question {\n  id\n  definition_id\n  key\n  title\n  dataPointValueType\n  options {\n    id\n    value_string\n    value\n    label\n  }\n  questionType\n  userQuestionType\n  questionConfig {\n    recode_enabled\n    mandatory\n    use_select\n    slider {\n      min\n      max\n      step_value\n      display_marks\n      min_label\n      max_label\n      is_value_tooltip_on\n      show_min_max_values\n    }\n    phone {\n      default_country\n      available_countries\n    }\n    number {\n      range {\n        min\n        max\n        enabled\n      }\n    }\n    multiple_select {\n      range {\n        min\n        max\n        enabled\n      }\n      exclusive_option {\n        option_id\n        enabled\n      }\n    }\n    date {\n      allowed_dates\n      include_date_of_response\n    }\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment Form on Form {\n  id\n  key\n  title\n  trademark\n  definition_id\n  release_id\n  questions {\n    ...Question\n  }\n}\n    ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HostedSession on HostedSession {\n  id\n  pathway_id\n  status\n  success_url\n  cancel_url\n  stakeholder {\n    id\n    type\n    name\n  }\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment Activity on Activity {\n  id\n  date\n  status\n  form_display_mode\n  object {\n    id\n    type\n    name\n  }\n  indirect_object {\n    id\n    type\n    name\n  }\n  action_component {\n    definition_id\n    release_id\n    title\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetChecklist($id: String!) {\n  checklist(id: $id) {\n    checklist {\n      title\n      items\n    }\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CompleteExtensionActivity($input: CompleteExtensionActivityInput!) {\n  completeExtensionActivity(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation EvaluateFormRules($input: EvaluateFormRulesInput!) {\n  evaluateFormRules(input: $input) {\n    results {\n      question_id\n      rule_id\n      satisfied\n    }\n  }\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetExtensionActivityDetails($id: String!) {\n  extensionActivityRecord(id: $id) {\n    record {\n      id\n      activity_id\n      pathway_id\n      data_points {\n        label\n        value\n      }\n      plugin_key\n      plugin_action_key\n      fields {\n        id\n        type\n        label\n        value\n      }\n      date\n      settings {\n        value\n        label\n        key\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetForm($id: String!) {\n  form(id: $id) {\n    form {\n      ...Form\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetFormResponse($pathway_id: String!, $activity_id: String!) {\n  formResponse(pathway_id: $pathway_id, activity_id: $activity_id) {\n    response {\n      answers {\n        question_id\n        value\n        value_type\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    subscription OnHostedSessionCompleted {\n  sessionCompleted {\n    ...HostedSession\n  }\n}\n    ",
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    subscription OnHostedSessionExpired {\n  sessionExpired {\n    ...HostedSession\n  }\n}\n    ",
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetHostedSession {\n  hostedSession {\n    session {\n      ...HostedSession\n    }\n    branding {\n      logo_url\n      hosted_page_title\n      accent_color\n      hosted_page_auto_progress\n      hosted_page_autosave\n      custom_theme\n    }\n    metadata {\n      pathway_definition_id\n      tenant_id\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetMessage($id: String!) {\n  message(id: $id) {\n    message {\n      id\n      body\n      subject\n      format\n      attachments {\n        id\n        name\n        type\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation MarkMessageAsRead($input: MarkMessageAsReadInput!) {\n  markMessageAsRead(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetHostedSessionActivities($only_stakeholder_activities: Boolean) {\n  hostedSessionActivities(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    success\n    activities {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    subscription OnSessionActivityCompleted($only_stakeholder_activities: Boolean!) {\n  sessionActivityCompleted(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    subscription OnSessionActivityCreated($only_stakeholder_activities: Boolean!) {\n  sessionActivityCreated(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    subscription OnSessionActivityExpired($only_stakeholder_activities: Boolean!) {\n  sessionActivityExpired(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    subscription OnSessionActivityUpdated($only_stakeholder_activities: Boolean!) {\n  sessionActivityUpdated(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SubmitChecklist($input: SubmitChecklistInput!) {\n  submitChecklist(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SubmitFormResponse($input: SubmitFormResponseInput!) {\n  submitFormResponse(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var result = {
    "possibleTypes": {
        "PaginationAndSortingPayload": [
            "ActivitiesPayload",
            "OrchestrationFactsPayload",
            "PathwaysPayload",
            "PatientsPayload",
            "PublishedPathwayDefinitionsPayload"
        ],
        "Payload": [
            "ActionPayload",
            "AddIdentifierToPatientPayload",
            "AddTrackPayload",
            "ApiCallPayload",
            "ApiCallsPayload",
            "BaselineInfoPayload",
            "CalculationResultsPayload",
            "CancelScheduledTracksPayload",
            "ChecklistPayload",
            "ClinicalNotePayload",
            "CompleteExtensionActivityPayload",
            "CreatePatientPayload",
            "CurrentUserPayload",
            "ElementsPayload",
            "EmptyPayload",
            "EmrReportPayload",
            "EvaluateFormRulesPayload",
            "ExtensionActivityRecordPayload",
            "FormPayload",
            "FormResponsePayload",
            "FormsPayload",
            "HostedPagesLinkPayload",
            "HostedSessionActivitiesPayload",
            "HostedSessionPayload",
            "MarkMessageAsReadPayload",
            "MessagePayload",
            "OrchestrationFactsPromptPayload",
            "PathwayDataPointDefinitionsPayload",
            "PathwayPayload",
            "PatientDemographicsPayload",
            "PatientPathwaysPayload",
            "PatientPayload",
            "RetryApiCallPayload",
            "RetryWebhookCallPayload",
            "ScheduleTrackPayload",
            "ScheduledStepsPayload",
            "ScheduledTracksPayload",
            "SearchPatientsPayload",
            "StakeholdersPayload",
            "StartHostedActivitySessionPayload",
            "StartHostedPathwaySessionFromLinkPayload",
            "StartHostedPathwaySessionPayload",
            "StartPathwayPayload",
            "StartPathwayWithPatientIdentifierPayload",
            "StopTrackPayload",
            "SubmitChecklistPayload",
            "SubmitFormResponsePayload",
            "TracksPayload",
            "UpdatePatientDemographicsQueryPayload",
            "UpdatePatientLanguagePayload",
            "UpdatePatientPayload",
            "WebhookCallPayload",
            "WebhookCallsPayload"
        ]
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (result)));
var ActionType;
(function(ActionType) {
    ActionType["ApiCall"] = "API_CALL";
    ActionType["ApiCallGraphql"] = "API_CALL_GRAPHQL";
    ActionType["Calculation"] = "CALCULATION";
    ActionType["Checklist"] = "CHECKLIST";
    ActionType["ClinicalNote"] = "CLINICAL_NOTE";
    ActionType["Form"] = "FORM";
    ActionType["Message"] = "MESSAGE";
    ActionType["Plugin"] = "PLUGIN";
    ActionType["PushToEmr"] = "PUSH_TO_EMR";
})(ActionType || (ActionType = {}));
var ActivityAction;
(function(ActivityAction) {
    ActivityAction["Activate"] = "ACTIVATE";
    ActivityAction["Added"] = "ADDED";
    ActivityAction["Assigned"] = "ASSIGNED";
    ActivityAction["Complete"] = "COMPLETE";
    ActivityAction["Computed"] = "COMPUTED";
    ActivityAction["Delegated"] = "DELEGATED";
    ActivityAction["Deliver"] = "DELIVER";
    ActivityAction["Discarded"] = "DISCARDED";
    ActivityAction["Expired"] = "EXPIRED";
    ActivityAction["Failed"] = "FAILED";
    ActivityAction["FailedToSend"] = "FAILED_TO_SEND";
    ActivityAction["Generated"] = "GENERATED";
    ActivityAction["IsWaitingOn"] = "IS_WAITING_ON";
    ActivityAction["Postponed"] = "POSTPONED";
    ActivityAction["Processed"] = "PROCESSED";
    ActivityAction["Read"] = "READ";
    ActivityAction["Remind"] = "REMIND";
    ActivityAction["Reported"] = "REPORTED";
    ActivityAction["Scheduled"] = "SCHEDULED";
    ActivityAction["Send"] = "SEND";
    ActivityAction["Skipped"] = "SKIPPED";
    ActivityAction["Stopped"] = "STOPPED";
    ActivityAction["Submitted"] = "SUBMITTED";
})(ActivityAction || (ActivityAction = {}));
var ActivityObjectType;
(function(ActivityObjectType) {
    ActivityObjectType["Action"] = "ACTION";
    ActivityObjectType["ApiCall"] = "API_CALL";
    ActivityObjectType["Calculation"] = "CALCULATION";
    ActivityObjectType["Checklist"] = "CHECKLIST";
    ActivityObjectType["ClinicalNote"] = "CLINICAL_NOTE";
    ActivityObjectType["EmrReport"] = "EMR_REPORT";
    ActivityObjectType["EmrRequest"] = "EMR_REQUEST";
    ActivityObjectType["EvaluatedRule"] = "EVALUATED_RULE";
    ActivityObjectType["Form"] = "FORM";
    ActivityObjectType["Message"] = "MESSAGE";
    ActivityObjectType["Pathway"] = "PATHWAY";
    ActivityObjectType["Patient"] = "PATIENT";
    ActivityObjectType["Plugin"] = "PLUGIN";
    ActivityObjectType["PluginAction"] = "PLUGIN_ACTION";
    ActivityObjectType["Reminder"] = "REMINDER";
    ActivityObjectType["Stakeholder"] = "STAKEHOLDER";
    ActivityObjectType["Step"] = "STEP";
    ActivityObjectType["Track"] = "TRACK";
    ActivityObjectType["User"] = "USER";
})(ActivityObjectType || (ActivityObjectType = {}));
var ActivityResolution;
(function(ActivityResolution) {
    ActivityResolution["Expired"] = "EXPIRED";
    ActivityResolution["Failure"] = "FAILURE";
    ActivityResolution["Success"] = "SUCCESS";
})(ActivityResolution || (ActivityResolution = {}));
var ActivityStatus;
(function(ActivityStatus) {
    ActivityStatus["Active"] = "ACTIVE";
    ActivityStatus["Canceled"] = "CANCELED";
    ActivityStatus["Done"] = "DONE";
    ActivityStatus["Expired"] = "EXPIRED";
    ActivityStatus["Failed"] = "FAILED";
})(ActivityStatus || (ActivityStatus = {}));
var ActivitySubjectType;
(function(ActivitySubjectType) {
    ActivitySubjectType["ApiCall"] = "API_CALL";
    ActivitySubjectType["Awell"] = "AWELL";
    ActivitySubjectType["Plugin"] = "PLUGIN";
    ActivitySubjectType["Stakeholder"] = "STAKEHOLDER";
    ActivitySubjectType["User"] = "USER";
})(ActivitySubjectType || (ActivitySubjectType = {}));
var AllowedDatesOptions;
(function(AllowedDatesOptions) {
    AllowedDatesOptions["All"] = "ALL";
    AllowedDatesOptions["Future"] = "FUTURE";
    AllowedDatesOptions["Past"] = "PAST";
})(AllowedDatesOptions || (AllowedDatesOptions = {}));
var ApiCallRequestMethod;
(function(ApiCallRequestMethod) {
    ApiCallRequestMethod["Delete"] = "DELETE";
    ApiCallRequestMethod["Get"] = "GET";
    ApiCallRequestMethod["Patch"] = "PATCH";
    ApiCallRequestMethod["Post"] = "POST";
    ApiCallRequestMethod["Put"] = "PUT";
})(ApiCallRequestMethod || (ApiCallRequestMethod = {}));
var ApiCallStatus;
(function(ApiCallStatus) {
    ApiCallStatus["Failed"] = "Failed";
    ApiCallStatus["InProgress"] = "InProgress";
    ApiCallStatus["Pending"] = "Pending";
    ApiCallStatus["PermanentlyFailed"] = "PermanentlyFailed";
    ApiCallStatus["Skipped"] = "Skipped";
    ApiCallStatus["Success"] = "Success";
})(ApiCallStatus || (ApiCallStatus = {}));
var BooleanOperator;
(function(BooleanOperator) {
    BooleanOperator["And"] = "AND";
    BooleanOperator["Or"] = "OR";
})(BooleanOperator || (BooleanOperator = {}));
var ConditionOperandType;
(function(ConditionOperandType) {
    ConditionOperandType["Boolean"] = "BOOLEAN";
    ConditionOperandType["DataPoint"] = "DATA_POINT";
    ConditionOperandType["DataSource"] = "DATA_SOURCE";
    ConditionOperandType["Number"] = "NUMBER";
    ConditionOperandType["NumbersArray"] = "NUMBERS_ARRAY";
    ConditionOperandType["String"] = "STRING";
    ConditionOperandType["StringsArray"] = "STRINGS_ARRAY";
})(ConditionOperandType || (ConditionOperandType = {}));
var ConditionOperator;
(function(ConditionOperator) {
    ConditionOperator["Contains"] = "CONTAINS";
    ConditionOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    ConditionOperator["IsAnyOf"] = "IS_ANY_OF";
    ConditionOperator["IsEmpty"] = "IS_EMPTY";
    ConditionOperator["IsEqualTo"] = "IS_EQUAL_TO";
    ConditionOperator["IsGreaterThan"] = "IS_GREATER_THAN";
    ConditionOperator["IsGreaterThanOrEqualTo"] = "IS_GREATER_THAN_OR_EQUAL_TO";
    ConditionOperator["IsInRange"] = "IS_IN_RANGE";
    ConditionOperator["IsLessThan"] = "IS_LESS_THAN";
    ConditionOperator["IsLessThanOrEqualTo"] = "IS_LESS_THAN_OR_EQUAL_TO";
    ConditionOperator["IsNoneOf"] = "IS_NONE_OF";
    ConditionOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
    ConditionOperator["IsNotEqualTo"] = "IS_NOT_EQUAL_TO";
    ConditionOperator["IsNotTrue"] = "IS_NOT_TRUE";
    ConditionOperator["IsToday"] = "IS_TODAY";
    ConditionOperator["IsTrue"] = "IS_TRUE";
})(ConditionOperator || (ConditionOperator = {}));
var DataPointSourceType;
(function(DataPointSourceType) {
    DataPointSourceType["ApiCall"] = "API_CALL";
    DataPointSourceType["ApiCallStatus"] = "API_CALL_STATUS";
    DataPointSourceType["Calculation"] = "CALCULATION";
    DataPointSourceType["DataPoint"] = "DATA_POINT";
    DataPointSourceType["ExtensionAction"] = "EXTENSION_ACTION";
    DataPointSourceType["ExtensionWebhook"] = "EXTENSION_WEBHOOK";
    DataPointSourceType["Form"] = "FORM";
    DataPointSourceType["Pathway"] = "PATHWAY";
    DataPointSourceType["PatientIdentifier"] = "PATIENT_IDENTIFIER";
    DataPointSourceType["PatientProfile"] = "PATIENT_PROFILE";
    DataPointSourceType["Step"] = "STEP";
    DataPointSourceType["Track"] = "TRACK";
})(DataPointSourceType || (DataPointSourceType = {}));
var DataPointValueType;
(function(DataPointValueType) {
    DataPointValueType["Boolean"] = "BOOLEAN";
    DataPointValueType["Date"] = "DATE";
    DataPointValueType["Json"] = "JSON";
    DataPointValueType["Number"] = "NUMBER";
    DataPointValueType["NumbersArray"] = "NUMBERS_ARRAY";
    DataPointValueType["String"] = "STRING";
    DataPointValueType["StringsArray"] = "STRINGS_ARRAY";
    DataPointValueType["Telephone"] = "TELEPHONE";
})(DataPointValueType || (DataPointValueType = {}));
var ElementStatus;
(function(ElementStatus) {
    ElementStatus["Active"] = "ACTIVE";
    ElementStatus["Discarded"] = "DISCARDED";
    ElementStatus["Done"] = "DONE";
    ElementStatus["Postponed"] = "POSTPONED";
    ElementStatus["Scheduled"] = "SCHEDULED";
    ElementStatus["Stopped"] = "STOPPED";
})(ElementStatus || (ElementStatus = {}));
var ElementType;
(function(ElementType) {
    ElementType["Action"] = "ACTION";
    ElementType["Pathway"] = "PATHWAY";
    ElementType["Step"] = "STEP";
    ElementType["Track"] = "TRACK";
    ElementType["Trigger"] = "TRIGGER";
})(ElementType || (ElementType = {}));
var ExtensionActionFieldType;
(function(ExtensionActionFieldType) {
    ExtensionActionFieldType["Boolean"] = "BOOLEAN";
    ExtensionActionFieldType["Date"] = "DATE";
    ExtensionActionFieldType["Html"] = "HTML";
    ExtensionActionFieldType["Json"] = "JSON";
    ExtensionActionFieldType["Numeric"] = "NUMERIC";
    ExtensionActionFieldType["NumericArray"] = "NUMERIC_ARRAY";
    ExtensionActionFieldType["String"] = "STRING";
    ExtensionActionFieldType["StringArray"] = "STRING_ARRAY";
    ExtensionActionFieldType["Text"] = "TEXT";
})(ExtensionActionFieldType || (ExtensionActionFieldType = {}));
var FormDisplayMode;
(function(FormDisplayMode) {
    FormDisplayMode["Conversational"] = "CONVERSATIONAL";
    FormDisplayMode["Regular"] = "REGULAR";
})(FormDisplayMode || (FormDisplayMode = {}));
var HostedSessionStakeholderType;
(function(HostedSessionStakeholderType) {
    HostedSessionStakeholderType["Patient"] = "PATIENT";
    HostedSessionStakeholderType["Stakeholder"] = "STAKEHOLDER";
})(HostedSessionStakeholderType || (HostedSessionStakeholderType = {}));
var HostedSessionStatus;
(function(HostedSessionStatus) {
    HostedSessionStatus["Active"] = "ACTIVE";
    HostedSessionStatus["Completed"] = "COMPLETED";
    HostedSessionStatus["Expired"] = "EXPIRED";
})(HostedSessionStatus || (HostedSessionStatus = {}));
var MessageAttachmentType;
(function(MessageAttachmentType) {
    MessageAttachmentType["File"] = "FILE";
    MessageAttachmentType["Link"] = "LINK";
    MessageAttachmentType["Video"] = "VIDEO";
})(MessageAttachmentType || (MessageAttachmentType = {}));
var MessageFormat;
(function(MessageFormat) {
    MessageFormat["Html"] = "HTML";
    MessageFormat["Slate"] = "SLATE";
})(MessageFormat || (MessageFormat = {}));
var PathwayStatus;
(function(PathwayStatus) {
    PathwayStatus["Active"] = "active";
    PathwayStatus["Completed"] = "completed";
    PathwayStatus["MissingBaselineInfo"] = "missing_baseline_info";
    PathwayStatus["Starting"] = "starting";
    PathwayStatus["Stopped"] = "stopped";
})(PathwayStatus || (PathwayStatus = {}));
var QuestionType;
(function(QuestionType) {
    QuestionType["Input"] = "INPUT";
    QuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    QuestionType["NoInput"] = "NO_INPUT";
})(QuestionType || (QuestionType = {}));
var Sex;
(function(Sex) {
    Sex["Female"] = "FEMALE";
    Sex["Male"] = "MALE";
    Sex["NotKnown"] = "NOT_KNOWN";
})(Sex || (Sex = {}));
var StakeholderClinicalAppRole;
(function(StakeholderClinicalAppRole) {
    StakeholderClinicalAppRole["Caregiver"] = "CAREGIVER";
    StakeholderClinicalAppRole["Patient"] = "PATIENT";
    StakeholderClinicalAppRole["Physician"] = "PHYSICIAN";
})(StakeholderClinicalAppRole || (StakeholderClinicalAppRole = {}));
var SwimlaneItemCategory;
(function(SwimlaneItemCategory) {
    SwimlaneItemCategory["Action"] = "ACTION";
    SwimlaneItemCategory["PathwayEnd"] = "PATHWAY_END";
    SwimlaneItemCategory["PathwayStart"] = "PATHWAY_START";
    SwimlaneItemCategory["Step"] = "STEP";
    SwimlaneItemCategory["Track"] = "TRACK";
    SwimlaneItemCategory["TrackEnd"] = "TRACK_END";
    SwimlaneItemCategory["TrackStart"] = "TRACK_START";
})(SwimlaneItemCategory || (SwimlaneItemCategory = {}));
var SwimlaneItemType;
(function(SwimlaneItemType) {
    SwimlaneItemType["Active"] = "active";
    SwimlaneItemType["Completed"] = "completed";
    SwimlaneItemType["Pending"] = "pending";
    SwimlaneItemType["Possible"] = "possible";
})(SwimlaneItemType || (SwimlaneItemType = {}));
var UserQuestionType;
(function(UserQuestionType) {
    UserQuestionType["Date"] = "DATE";
    UserQuestionType["Description"] = "DESCRIPTION";
    UserQuestionType["LongText"] = "LONG_TEXT";
    UserQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    UserQuestionType["MultipleChoiceGrid"] = "MULTIPLE_CHOICE_GRID";
    UserQuestionType["MultipleSelect"] = "MULTIPLE_SELECT";
    UserQuestionType["Number"] = "NUMBER";
    UserQuestionType["ShortText"] = "SHORT_TEXT";
    UserQuestionType["Signature"] = "SIGNATURE";
    UserQuestionType["Slider"] = "SLIDER";
    UserQuestionType["Telephone"] = "TELEPHONE";
    UserQuestionType["YesNo"] = "YES_NO";
})(UserQuestionType || (UserQuestionType = {}));
var QuestionFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var FormFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1(), QuestionFragmentDoc);
var HostedSessionFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var ActivityFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var GetChecklistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
/**
 * __useGetChecklistQuery__
 *
 * To run a query within a React component, call `useGetChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetChecklistQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(GetChecklistDocument, options);
}
function useGetChecklistLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetChecklistDocument, options);
}
var CompleteExtensionActivityDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5(), ActivityFragmentDoc);
/**
 * __useCompleteExtensionActivityMutation__
 *
 * To run a mutation, you first call `useCompleteExtensionActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteExtensionActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeExtensionActivityMutation, { data, loading, error }] = useCompleteExtensionActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCompleteExtensionActivityMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D(CompleteExtensionActivityDocument, options);
}
var EvaluateFormRulesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
/**
 * __useEvaluateFormRulesMutation__
 *
 * To run a mutation, you first call `useEvaluateFormRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateFormRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateFormRulesMutation, { data, loading, error }] = useEvaluateFormRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useEvaluateFormRulesMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D(EvaluateFormRulesDocument, options);
}
var GetExtensionActivityDetailsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
/**
 * __useGetExtensionActivityDetailsQuery__
 *
 * To run a query within a React component, call `useGetExtensionActivityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionActivityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionActivityDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetExtensionActivityDetailsQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(GetExtensionActivityDetailsDocument, options);
}
function useGetExtensionActivityDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetExtensionActivityDetailsDocument, options);
}
var GetFormDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8(), FormFragmentDoc);
/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetFormQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(GetFormDocument, options);
}
function useGetFormLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFormDocument, options);
}
var GetFormResponseDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9());
/**
 * __useGetFormResponseQuery__
 *
 * To run a query within a React component, call `useGetFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseQuery({
 *   variables: {
 *      pathway_id: // value for 'pathway_id'
 *      activity_id: // value for 'activity_id'
 *   },
 * });
 */ function useGetFormResponseQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetFormResponseDocument, options);
}
function useGetFormResponseLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFormResponseDocument, options);
}
var OnHostedSessionCompletedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10(), HostedSessionFragmentDoc);
/**
 * __useOnHostedSessionCompletedSubscription__
 *
 * To run a query within a React component, call `useOnHostedSessionCompletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnHostedSessionCompletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnHostedSessionCompletedSubscription({
 *   variables: {
 *   },
 * });
 */ function useOnHostedSessionCompletedSubscription(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useSubscription */ .m(OnHostedSessionCompletedDocument, options);
}
var OnHostedSessionExpiredDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject11(), HostedSessionFragmentDoc);
/**
 * __useOnHostedSessionExpiredSubscription__
 *
 * To run a query within a React component, call `useOnHostedSessionExpiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnHostedSessionExpiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnHostedSessionExpiredSubscription({
 *   variables: {
 *   },
 * });
 */ function useOnHostedSessionExpiredSubscription(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useSubscription */ .m(OnHostedSessionExpiredDocument, options);
}
var GetHostedSessionDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject12(), HostedSessionFragmentDoc);
/**
 * __useGetHostedSessionQuery__
 *
 * To run a query within a React component, call `useGetHostedSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedSessionQuery({
 *   variables: {
 *   },
 * });
 */ function useGetHostedSessionQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(GetHostedSessionDocument, options);
}
function useGetHostedSessionLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetHostedSessionDocument, options);
}
var GetMessageDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject13());
/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetMessageQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(GetMessageDocument, options);
}
function useGetMessageLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetMessageDocument, options);
}
var MarkMessageAsReadDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject14(), ActivityFragmentDoc);
/**
 * __useMarkMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageAsReadMutation, { data, loading, error }] = useMarkMessageAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useMarkMessageAsReadMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D(MarkMessageAsReadDocument, options);
}
var GetHostedSessionActivitiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject15(), ActivityFragmentDoc);
/**
 * __useGetHostedSessionActivitiesQuery__
 *
 * To run a query within a React component, call `useGetHostedSessionActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedSessionActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedSessionActivitiesQuery({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useGetHostedSessionActivitiesQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(GetHostedSessionActivitiesDocument, options);
}
function useGetHostedSessionActivitiesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetHostedSessionActivitiesDocument, options);
}
var OnSessionActivityCompletedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject16(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityCompletedSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityCompletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityCompletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityCompletedSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityCompletedSubscription(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useSubscription */ .m(OnSessionActivityCompletedDocument, options);
}
var OnSessionActivityCreatedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject17(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityCreatedSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityCreatedSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityCreatedSubscription(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useSubscription */ .m(OnSessionActivityCreatedDocument, options);
}
var OnSessionActivityExpiredDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject18(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityExpiredSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityExpiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityExpiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityExpiredSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityExpiredSubscription(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useSubscription */ .m(OnSessionActivityExpiredDocument, options);
}
var OnSessionActivityUpdatedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject19(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityUpdatedSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityUpdatedSubscription(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useSubscription(OnSessionActivityUpdatedDocument, options);
}
var SubmitChecklistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject20(), ActivityFragmentDoc);
/**
 * __useSubmitChecklistMutation__
 *
 * To run a mutation, you first call `useSubmitChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChecklistMutation, { data, loading, error }] = useSubmitChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useSubmitChecklistMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D(SubmitChecklistDocument, options);
}
var SubmitFormResponseDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject21(), ActivityFragmentDoc);
/**
 * __useSubmitFormResponseMutation__
 *
 * To run a mutation, you first call `useSubmitFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResponseMutation, { data, loading, error }] = useSubmitFormResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useSubmitFormResponseMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D(SubmitFormResponseDocument, options);
}


/***/ }),

/***/ 6455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error_page":"errorPage_error_page__To78P","error_icon_container":"errorPage_error_icon_container__r4KgY","error_icon_shadow":"errorPage_error_icon_shadow__RWlDP","error_icon":"errorPage_error_icon__MQrjO","error_text":"errorPage_error_text__M_TI3","error_page_content":"errorPage_error_page_content__WGaQo","try_again_btn":"errorPage_try_again_btn__Fs2V4"};

/***/ }),

/***/ 7640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"remoteSingleSelectAction_container__iMSj6","selectContainer":"remoteSingleSelectAction_selectContainer__VjCDP","buttonContainer":"remoteSingleSelectAction_buttonContainer__Q2krW","error":"remoteSingleSelectAction_error__za59X"};

/***/ }),

/***/ 1397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"embeddedSigning_wrapper__5zcQi","flex-full":"embeddedSigning_flex-full__UzV2e","iframe-loaded":"embeddedSigning_iframe-loaded__E_8vP","iframe-loading":"embeddedSigning_iframe-loading__RuVf_"};

/***/ }),

/***/ 5605:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"RequestVideoVisit_container__XyNGx"};

/***/ }),

/***/ 4612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"completeFlowAction_container__kpqbH"};

/***/ }),

/***/ 3800:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DobCheck_container__wgmGX","label":"DobCheck_label__LkFOC","inputWrapper":"DobCheck_inputWrapper__qq4t6","submitButton":"DobCheck_submitButton__0o6F4"};

/***/ }),

/***/ 5408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"EnterMedication_container__b1EpJ","groupMedsListContainer":"EnterMedication_groupMedsListContainer__s39YS","singleMedsListContainer":"EnterMedication_singleMedsListContainer__R0c5f","label":"EnterMedication_label__9sFDi","addMedsButton":"EnterMedication_addMedsButton__8LmzX","submitButton":"EnterMedication_submitButton__5rLiN"};

/***/ }),

/***/ 9710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message":"PatientRecommendation_message__JEWtr","slate-MediaEmbedElement-input":"PatientRecommendation_slate-MediaEmbedElement-input__REjaL","slate-MediaEmbedElement-iframe":"PatientRecommendation_slate-MediaEmbedElement-iframe__a6i7C","content":"PatientRecommendation_content__kv201","title":"PatientRecommendation_title__cUsgn","button_wrapper":"PatientRecommendation_button_wrapper__KEwDH"};

/***/ }),

/***/ 3064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"redirect":"Redirect_redirect__FQvf4"};

/***/ }),

/***/ 9137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"EmbeddedCheckout_container__hPuY_"};

/***/ }),

/***/ 3614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"loadingPage_loading_container__DAR1u","logo_box":"loadingPage_logo_box__ENtGT","logo_shadow":"loadingPage_logo_shadow__bTptP","wave":"loadingPage_wave__S45eQ","loading_indicators":"loadingPage_loading_indicators__W56PS","loading_indicator":"loadingPage_loading_indicator__BTmn_"};

/***/ }),

/***/ 8936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main_content":"ActivityLayout_main_content__zLibQ","container":"ActivityLayout_container__oGmjP","content":"ActivityLayout_content__ysldR","button_wrapper":"ActivityLayout_button_wrapper__KUHYy"};

/***/ }),

/***/ 4311:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIgogICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgPHBhdGggZD0iTTQuMjIyMzkgMTkuNzc4QzQuNjg2MjYgMjAuMjQyNSA1LjIzNzM2IDIwLjYxMDggNS44NDQwMSAyMC44NjE3QzYuNDUwNjYgMjEuMTEyNiA3LjEwMDkgMjEuMjQxMSA3Ljc1NzM5IDIxLjI0QzguNDE0MDIgMjEuMjQxMSA5LjA2NDQxIDIxLjExMjUgOS42NzEyMiAyMC44NjE3QzEwLjI3OCAyMC42MTA4IDEwLjgyOTMgMjAuMjQyNSAxMS4yOTM0IDE5Ljc3OEwxNC4xMjE0IDE2Ljk0OUwxMi43MDc0IDE1LjUzNUw5Ljg3OTM5IDE4LjM2NEM5LjMxNTg2IDE4LjkyNSA4LjU1MzA2IDE5LjIzOTkgNy43NTc4OSAxOS4yMzk5QzYuOTYyNzIgMTkuMjM5OSA2LjE5OTkyIDE4LjkyNSA1LjYzNjM5IDE4LjM2NEM1LjA3NDg5IDE3LjgwMDcgNC43NTk2IDE3LjAzNzggNC43NTk2IDE2LjI0MjVDNC43NTk2IDE1LjQ0NzEgNS4wNzQ4OSAxNC42ODQyIDUuNjM2MzkgMTQuMTIxTDguNDY1MzkgMTEuMjkzTDcuMDUxMzkgOS44Nzg5Nkw0LjIyMjM5IDEyLjcwN0MzLjI4NjIgMTMuNjQ1NCAyLjc2MDQ0IDE0LjkxNjkgMi43NjA0NCAxNi4yNDI1QzIuNzYwNDQgMTcuNTY4IDMuMjg2MiAxOC44Mzk1IDQuMjIyMzkgMTkuNzc4Wk0xOS43Nzg0IDExLjI5M0MyMC43MTQxIDEwLjM1NDIgMjEuMjM5NSA5LjA4Mjg4IDIxLjIzOTUgNy43NTc0NkMyMS4yMzk1IDYuNDMyMDQgMjAuNzE0MSA1LjE2MDY4IDE5Ljc3ODQgNC4yMjE5NkMxOC44Mzk5IDMuMjg1NzcgMTcuNTY4NSAyLjc2MDAxIDE2LjI0MjkgMi43NjAwMUMxNC45MTczIDIuNzYwMDEgMTMuNjQ1OCAzLjI4NTc3IDEyLjcwNzQgNC4yMjE5Nkw5Ljg3OTM5IDcuMDUwOTZMMTEuMjkzNCA4LjQ2NDk2TDE0LjEyMTQgNS42MzU5NkMxNC42ODQ5IDUuMDc0OTUgMTUuNDQ3NyA0Ljc1OTk5IDE2LjI0MjkgNC43NTk5OUMxNy4wMzgxIDQuNzU5OTkgMTcuODAwOSA1LjA3NDk1IDE4LjM2NDQgNS42MzU5NkMxOC45MjU5IDYuMTk5MjMgMTkuMjQxMiA2Ljk2MjEzIDE5LjI0MTIgNy43NTc0NkMxOS4yNDEyIDguNTUyNzkgMTguOTI1OSA5LjMxNTY5IDE4LjM2NDQgOS44Nzg5NkwxNS41MzU0IDEyLjcwN0wxNi45NDk0IDE0LjEyMUwxOS43Nzg0IDExLjI5M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgICAgIDxwYXRoIGQ9Ik04LjQ2NDM4IDE2Ljk1TDcuMDQ5MzggMTUuNTM2TDE1LjUzNjQgNy4wNDk5NkwxNi45NTA0IDguNDY0OTZMOC40NjQzOCAxNi45NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4="

/***/ })

}]);